const {
  DRAFT_STATUTES_MENTIONS,
} = require('@shinetools/capital-deposits-library');

const ERROR_TAGS = {
  BLACK_AND_WHITE: 'BLACK_AND_WHITE',
  BLURRY: 'BLURRY',
  BRIGHTNESS: 'BRIGHTNESS',
  CROPPED: 'CROPPED',
  EXPIRED: 'EXPIRED',
  FALSIFIED: 'FALSIFIED',
  ID_DOCUMENT_SECURITY_INVISIBLE: 'ID_DOCUMENT_SECURITY_INVISIBLE',
  ID_DOCUMENT_TOO_BRIGHT: 'ID_DOCUMENT_TOO_BRIGHT',
  ID_DOCUMENT_TOO_DARK: 'ID_DOCUMENT_TOO_DARK',
  ID_INCOHERENT: 'ID_INCOHERENT',
  INCOMPLETE: 'INCOMPLETE',
  JDD_INCOHERENT: 'JDD_INCOHERENT',
  JDD_INCOHERENT_NOM: 'JDD_INCOHERENT_NOM',
  KYB_DRAFT_STATUTES_ACTIVITY_UNCLEAR: 'KYB_DRAFT_STATUTES_ACTIVITY_UNCLEAR',
  KYB_DRAFT_STATUTES_EDIT_ACCOUNT_HOLDER:
    'KYB_DRAFT_STATUTES_EDIT_ACCOUNT_HOLDER',
  KYB_DRAFT_STATUTES_INCONSISTENT_ADDRESS:
    'KYB_DRAFT_STATUTES_INCONSISTENT_ADDRESS',
  KYB_DRAFT_STATUTES_INCONSISTENT_LEGAL_NAME:
    'KYB_DRAFT_STATUTES_INCONSISTENT_LEGAL_NAME',
  KYB_DRAFT_STATUTES_INCONSISTENT_NAME: 'KYB_DRAFT_STATUTES_INCONSISTENT_NAME',
  KYB_DRAFT_STATUTES_INCONSISTENT_SHARE_CAPITAL:
    'KYB_DRAFT_STATUTES_INCONSISTENT_SHARE_CAPITAL',
  KYB_DRAFT_STATUTES_LEGAL_NAME_INCLUDES_NAME:
    'KYB_DRAFT_STATUTES_LEGAL_NAME_INCLUDES_NAME',
  KYB_DRAFT_STATUTES_MISSING_ADDRESS: 'KYB_DRAFT_STATUTES_MISSING_ADDRESS',
  KYB_DRAFT_STATUTES_MISSING_ALLOCATION_OF_SHARES:
    'KYB_DRAFT_STATUTES_MISSING_ALLOCATION_OF_SHARES',
  KYB_DRAFT_STATUTES_MISSING_APPOINTMENT_DEED:
    'KYB_DRAFT_STATUTES_MISSING_APPOINTMENT_DEED',
  KYB_DRAFT_STATUTES_MISSING_BIRTH_DATE:
    'KYB_DRAFT_STATUTES_MISSING_BIRTH_DATE',
  KYB_DRAFT_STATUTES_MISSING_MENTION_APPENDIX:
    'KYB_DRAFT_STATUTES_MISSING_MENTION_APPENDIX',
  KYB_DRAFT_STATUTES_MISSING_MENTION_APPORTS:
    'KYB_DRAFT_STATUTES_MISSING_MENTION_APPORTS',
  KYB_DRAFT_STATUTES_MISSING_SHAREHOLDERS:
    'KYB_DRAFT_STATUTES_MISSING_SHAREHOLDERS',
  KYB_DRAFT_STATUTES_MISSING_SHARES: 'KYB_DRAFT_STATUTES_MISSING_SHARES',
  KYB_DRAFT_STATUTES_NOT_ACCEPTED: 'KYB_DRAFT_STATUTES_NOT_ACCEPTED',
  KYB_DRAFT_STATUTES_NOT_AUTHENTICATED: 'KYB_DRAFT_STATUTES_NOT_AUTHENTICATED',
  KYB_DRAFT_STATUTES_NOT_COMPLETE: 'KYB_DRAFT_STATUTES_NOT_COMPLETE',
  KYB_DRAFT_STATUTES_OTHER_MENTIONS: 'KYB_DRAFT_STATUTES_OTHER_MENTIONS',
  KYB_DRAFT_STATUTES_OTHER_MENTIONS_APPENDIX:
    'KYB_DRAFT_STATUTES_OTHER_MENTIONS_APPENDIX',
  KYB_DRAFT_STATUTES_SHAREHOLDER_INCONSISTENT_ADDRESS:
    'KYB_DRAFT_STATUTES_SHAREHOLDER_INCONSISTENT_ADDRESS',
  KYB_DRAFT_STATUTES_SHAREHOLDER_INCONSISTENT_BIRTHDATE:
    'KYB_DRAFT_STATUTES_SHAREHOLDER_INCONSISTENT_BIRTHDATE',
  KYB_DRAFT_STATUTES_SHARES_INCONSISTENT:
    'KYB_DRAFT_STATUTES_SHARES_INCONSISTENT',
  KYB_DRAFT_STATUTES_UNCLEAR_ACTIVITY: 'KYB_DRAFT_STATUTES_UNCLEAR_ACTIVITY',
  KYB_DRAFT_STATUTES_VARIABLE_CAPITAL: 'KYB_DRAFT_STATUTES_VARIABLE_CAPITAL',
  KYB_DRAFT_STATUTES_VARIABLE_CAPITAL_INCONSISTENT:
    'KYB_DRAFT_STATUTES_VARIABLE_CAPITAL_INCONSISTENT',
  KYB_INCONSISTENT_ADDRESS: 'KYB_INCONSISTENT_ADDRESS',
  KYB_INCONSISTENT_NAME: 'KYB_INCONSISTENT_NAME',
  KYB_INCONSISTENT_SIREN: 'KYB_INCONSISTENT_SIREN',
  KYB_INCONSISTENT_SIRET: 'KYB_INCONSISTENT_SIRET',
  KYB_INPI_INCONSISTENT_LEGAL_FORM: 'KYB_INPI_INCONSISTENT_LEGAL_FORM',
  KYB_KBIS_EXPIRED: 'KYB_KBIS_EXPIRED',
  KYB_KBIS_INCONSISTENT_SIRET: 'KYB_KBIS_INCONSISTENT_SIRET',
  KYB_MANDATE_INCONSISTENT_COMPANY: 'KYB_MANDATE_INCONSISTENT_COMPANY',
  KYB_MANDATE_INCONSISTENT_CONTRACTOR: 'KYB_MANDATE_INCONSISTENT_CONTRACTOR',
  KYB_MANDATE_INCONSISTENT_MANDATEE: 'KYB_MANDATE_INCONSISTENT_MANDATEE',
  KYB_MANDATE_MISSING_MENTION_POWER: 'KYB_MANDATE_MISSING_MENTION_POWER',
  KYB_NOT_UP_TO_DATE: 'KYB_NOT_UP_TO_DATE',
  KYB_REGISTRATION_DOC_NOT_SUPPORTED: 'KYB_REGISTRATION_DOC_NOT_SUPPORTED',
  KYB_STATUTES_BENEFICIARY_MISSING: 'KYB_STATUTES_BENEFICIARY_MISSING',
  KYB_STATUTES_DOC_NOT_SUPPORTED: 'KYB_STATUTES_DOC_NOT_SUPPORTED',
  KYB_STATUTES_INCOMPLETE: 'KYB_STATUTES_INCOMPLETE',
  KYB_STATUTES_NOT_AUTHENTICATED: 'KYB_STATUTES_NOT_AUTHENTICATED',
  KYB_STATUTES_NOT_COMPLETE: 'KYB_STATUTES_NOT_COMPLETE',
  KYB_STATUTES_NOT_UP_TO_DATE: 'KYB_STATUTES_NOT_UP_TO_DATE',
  KYB_STATUTES_REMOVE_BENEFICIARY: 'KYB_STATUTES_REMOVE_BENEFICIARY',
  KYB_STATUTES_SIGNATURE_MISSING: 'KYB_STATUTES_SIGNATURE_MISSING',
  KYB_STATUTES_SUBSCRIBERS_LIST_MISSING:
    'KYB_STATUTES_SUBSCRIBERS_LIST_MISSING',
  KYB_STATUTES_WRONG_ACCOUNT_HOLDER: 'KYB_STATUTES_WRONG_ACCOUNT_HOLDER',
  KYB_UNCLEAR_ACTIVITY: 'KYB_UNCLEAR_ACTIVITY',
  KYC_BIRTH_PLACE_INCONSISTENT: 'KYC_BIRTH_PLACE_INCONSISTENT',
  KYC_DRIVING_LICENCE_NOT_SUPPORTED: 'KYC_DRIVING_LICENCE_NOT_SUPPORTED',
  KYC_HOST_INCONSISTENT_NAME: 'KYC_HOST_INCONSISTENT_NAME',
  KYC_ID_ASSISTED_DOCUMENT_PHOTO: 'KYC_ID_ASSISTED_DOCUMENT_PHOTO',
  KYC_ID_ASSISTED_SELFIE: 'KYC_ID_ASSISTED_SELFIE',
  KYC_ID_ASSISTED_VIDEO: 'KYC_ID_ASSISTED_VIDEO',
  KYC_ID_DATE_OF_BIRTH_DOES_NOT_MATCH: 'KYC_ID_DATE_OF_BIRTH_DOES_NOT_MATCH',
  KYC_ID_DATE_OF_BIRTH_DOES_NOT_MATCH_PREVIOUS_ID:
    'KYC_ID_DATE_OF_BIRTH_DOES_NOT_MATCH_PREVIOUS_ID',
  KYC_ID_DOCUMENT_CONDITION_INSUFFICIENT:
    'KYC_ID_DOCUMENT_CONDITION_INSUFFICIENT',
  KYC_ID_ERROR_OTHER_DOCUMENT: 'KYC_ID_ERROR_OTHER_DOCUMENT',
  KYC_ID_ERROR_OTHER_SELFIE: 'KYC_ID_ERROR_OTHER_SELFIE',
  KYC_ID_ERROR_OTHER_VIDEO: 'KYC_ID_ERROR_OTHER_VIDEO',
  KYC_ID_EXPIRED: 'KYC_ID_EXPIRED',
  KYC_ID_EXPIRY_DATE_DOES_NOT_MATCH: 'KYC_ID_EXPIRY_DATE_DOES_NOT_MATCH',
  KYC_ID_GDPR_BREACH: 'KYC_ID_GDPR_BREACH',
  KYC_ID_GDPR_BREACH_SELFIE: 'KYC_ID_GDPR_BREACH_SELFIE',
  KYC_ID_GDPR_BREACH_VIDEO: 'KYC_ID_GDPR_BREACH_VIDEO',
  KYC_ID_INADEQUATE_SELFIE: 'KYC_ID_INADEQUATE_SELFIE',
  KYC_ID_INADEQUATE_VIDEO: 'KYC_ID_INADEQUATE_VIDEO',
  KYC_ID_INCONSISTENT_NAME: 'KYC_ID_INCONSISTENT_NAME',
  KYC_ID_INCONSISTENT_SELFIE: 'KYC_ID_INCONSISTENT_SELFIE',
  KYC_ID_INCONSISTENT_SELFIE_FACE_NOT_VISIBLE:
    'KYC_ID_INCONSISTENT_SELFIE_FACE_NOT_VISIBLE',
  KYC_ID_INCONSISTENT_SELFIE_NOT_SAME_PERSON:
    'KYC_ID_INCONSISTENT_SELFIE_NOT_SAME_PERSON',
  KYC_ID_INCONSISTENT_SELFIE_TOO_BLURRY:
    'KYC_ID_INCONSISTENT_SELFIE_TOO_BLURRY',
  KYC_ID_INCONSISTENT_SELFIE_TOO_BRIGHT:
    'KYC_ID_INCONSISTENT_SELFIE_TOO_BRIGHT',
  KYC_ID_INCONSISTENT_SELFIE_TOO_DARK: 'KYC_ID_INCONSISTENT_SELFIE_TOO_DARK',
  KYC_ID_INCONSISTENT_VIDEO_TOO_BLURRY: 'KYC_ID_INCONSISTENT_VIDEO_TOO_BLURRY',
  KYC_ID_INCONSISTENT_VIDEO_TOO_BRIGHT: 'KYC_ID_INCONSISTENT_VIDEO_TOO_BRIGHT',
  KYC_ID_INCONSISTENT_VIDEO_TOO_DARK: 'KYC_ID_INCONSISTENT_VIDEO_TOO_DARK',
  KYC_ID_INVERTED: 'KYC_ID_INVERTED',
  KYC_ID_ISSUE_DATE_DOES_NOT_MATCH: 'KYC_ID_ISSUE_DATE_DOES_NOT_MATCH',
  KYC_ID_KYC_GENDER_DOES_NOT_MATCH: 'KYC_ID_KYC_GENDER_DOES_NOT_MATCH',
  KYC_ID_KYC_INVALID_ID_DOCUMENT: 'KYC_ID_KYC_INVALID_ID_DOCUMENT',
  KYC_ID_LIVENESS_FEATURE: 'KYC_ID_LIVENESS_FEATURE',
  KYC_ID_NAME_DOES_NOT_MATCH_PREVIOUS_ID:
    'KYC_ID_NAME_DOES_NOT_MATCH_PREVIOUS_ID',
  KYC_ID_NAME_FIELDS_DOES_NOT_MATCH: 'KYC_ID_NAME_FIELDS_DOES_NOT_MATCH',
  KYC_ID_NATIONALITY_DOES_NOT_MATCH: 'KYC_ID_NATIONALITY_DOES_NOT_MATCH',
  KYC_ID_NUMBER_DOES_NOT_MATCH: 'KYC_ID_NUMBER_DOES_NOT_MATCH',
  KYC_ID_PHOTO_BLOCKED: 'KYC_ID_PHOTO_BLOCKED',
  KYC_ID_PLACE_OF_BIRTH_DOES_NOT_MATCH: 'KYC_ID_PLACE_OF_BIRTH_DOES_NOT_MATCH',
  KYC_ID_PLACE_OF_BIRTH_DOES_NOT_MATCH_PREVIOUS_ID:
    'KYC_ID_PLACE_OF_BIRTH_DOES_NOT_MATCH_PREVIOUS_ID',
  KYC_ID_PLASTIC_COVER: 'KYC_ID_PLASTIC_COVER',
  KYC_ID_RECTO_VERSO_MISSING: 'KYC_ID_RECTO_VERSO_MISSING',
  KYC_MISSING_SELFIE: 'KYC_MISSING_SELFIE',
  KYC_PASSPORT_HOST_PAGE_MISSING: 'KYC_PASSPORT_HOST_PAGE_MISSING',
  KYC_PASSPORT_NON_EUROPEAN: 'KYC_PASSPORT_NON_EUROPEAN',
  KYC_PASSPORT_SECOND_PAGE_MISSING: 'KYC_PASSPORT_SECOND_PAGE_MISSING',
  KYC_POA_4G_BOX: 'KYC_POA_4G_BOX',
  KYC_POA_COMPANY_NAME: 'KYC_POA_COMPANY_NAME',
  KYC_POA_ENDED_INVOICE: 'KYC_POA_ENDED_INVOICE',
  KYC_POA_EXPIRED: 'KYC_POA_EXPIRED',
  KYC_POA_FIRSTNAME_MISSING: 'KYC_POA_FIRSTNAME_MISSING',
  KYC_POA_INCONSISTENT_ADDRESS: 'KYC_POA_INCONSISTENT_ADDRESS',
  KYC_POA_INCONSISTENT_NAME: 'KYC_POA_INCONSISTENT_NAME',
  KYC_POA_MOBILE: 'KYC_POA_MOBILE',
  KYC_POA_NAME_SLIGHTLY_DIFFERENT: 'KYC_POA_NAME_SLIGHTLY_DIFFERENT',
  KYC_POA_NO_CONTROL_POINT: 'KYC_POA_NO_CONTROL_POINT',
  KYC_POA_NOT_SUPPORTED: 'KYC_POA_NOT_SUPPORTED',
  KYC_POA_PAYMENT_SCHEDULE: 'KYC_POA_PAYMENT_SCHEDULE',
  KYC_POA_PLACE_OF_CONSUMPTION_ADDRESS: 'KYC_POA_PLACE_OF_CONSUMPTION_ADDRESS',
  KYC_POA_PRINTED: 'KYC_POA_PRINTED',
  KYC_POA_SCREENSHOT: 'KYC_POA_SCREENSHOT',
  KYC_POA_UNPAID_INVOICE: 'KYC_POA_UNPAID_INVOICE',
  KYC_PROOF_OF_ACCOMMODATION_ESIGNATURE:
    'KYC_PROOF_OF_ACCOMMODATION_ESIGNATURE',
  KYC_PROOF_OF_ACCOMMODATION_EXPIRED: 'KYC_PROOF_OF_ACCOMMODATION_EXPIRED',
  KYC_PROOF_OF_ACCOMMODATION_HOST_BIRTHDATE_MISMATCH:
    'KYC_PROOF_OF_ACCOMMODATION_HOST_BIRTHDATE_MISMATCH',
  KYC_PROOF_OF_ACCOMMODATION_INCONSISTENT_ADDRESS:
    'KYC_PROOF_OF_ACCOMMODATION_INCONSISTENT_ADDRESS',
  KYC_PROOF_OF_ACCOMMODATION_INCONSISTENT_SIGNATURE:
    'KYC_PROOF_OF_ACCOMMODATION_INCONSISTENT_SIGNATURE',
  KYC_PROOF_OF_ACCOMMODATION_NAME_SLIGHTLY_DIFFERENT:
    'KYC_PROOF_OF_ACCOMMODATION_NAME_SLIGHTLY_DIFFERENT',
  KYC_PROOF_OF_ACCOMMODATION_SIGNATURE_MISSING:
    'KYC_PROOF_OF_ACCOMMODATION_SIGNATURE_MISSING',
  KYC_PROOF_OF_ACCOMMODATION_USER_BIRTHDATE_MISMATCH:
    'KYC_PROOF_OF_ACCOMMODATION_USER_BIRTHDATE_MISMATCH',
  KYC_RESIDENCE_PERMIT_HOST_MISSING: 'KYC_RESIDENCE_PERMIT_HOST_MISSING',
  KYC_RESIDENCE_PERMIT_MISSING: 'KYC_RESIDENCE_PERMIT_MISSING',
  KYC_SHINE_START_POA_MENTION_MICRO_MISSING:
    'KYC_SHINE_START_POA_MENTION_MICRO_MISSING',
  KYC_SHINE_START_POA_NOT_SUPPORTED: 'KYC_SHINE_START_POA_NOT_SUPPORTED',
  KYC_SHINE_START_RESIDENCE_PERMIT_HOST_INCONSISTENT_ADDRESS:
    'KYC_SHINE_START_RESIDENCE_PERMIT_HOST_INCONSISTENT_ADDRESS',
  KYC_SHINE_START_RESIDENCE_PERMIT_INCONSISTENT_ADDRESS:
    'KYC_SHINE_START_RESIDENCE_PERMIT_INCONSISTENT_ADDRESS',
  MISSING: 'MISSING',
  NEED_ANOTHER: 'NEED_ANOTHER',
  NO_DATE: 'NO_DATE',
  NO_SIGNATURE: 'NO_SIGNATURE',
  NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
  OUT_OF_BOUNDS: 'OUT_OF_BOUNDS',
  PHOTOCOPY: 'PHOTOCOPY',
  SCAN: 'SCAN',
  SCREEN: 'SCREEN',
  SCREENSHOT: 'SCREENSHOT',
  TYPE_NOT_SUPPORTED: 'TYPE_NOT_SUPPORTED',
  UNREADABLE: 'UNREADABLE',
  UPLOAD_ERROR: 'UPLOAD_ERROR',
};

const errorTagsLocales = {
  en: {
    BLACK_AND_WHITE: {
      description: "can't be black and white, nor a photo of a screen",
      label: 'Black and white',
    },
    BLURRY: {
      description: 'the photo of your document is blurry',
      label: 'Blurry',
    },
    BRIGHTNESS: {
      description:
        'The **brightness** of the photo prevents us from reading the information correctly. Please start again, paying particular attention to its **readability**, to the **reflections** and to the fact that the photo is taken **in a luminous space**.',
      label: 'Brightness',
    },
    CROPPED: {
      description:
        'The photo of your ID is cropped (cut off). We invite you to repeat the identity verification step, making sure that you send us a complete photo of your ID in the frame, with the borders visible.',
      label: 'Cropped',
    },
    EXPIRED: {
      description: 'your document expired, or is older than 3 months',
      label: 'Expired',
    },
    FALSIFIED: {
      description:
        'this document does not seem to be an original. Please provide another document',
      label: 'Falsified',
    },
    ID_DOCUMENT_SECURITY_INVISIBLE: {
      description:
        'The **quality** of the photo prevents us from analysing your identity document correctly. We invite you to repeat the identity verification step, paying particular attention to its **readability**, to **reflections** and to the fact that the photo was taken **in a luminous space**.',
      label: 'Security features are not visible.',
    },
    ID_DOCUMENT_TOO_BRIGHT: {
      description:
        'The **brightness** of the photo prevents us from reading the information correctly. Please start again, paying particular attention to its **readability**, to the **reflections** and to the fact that the photo is taken **in a luminous space**.',
      label: 'ID document quality: Too bright',
    },
    ID_DOCUMENT_TOO_DARK: {
      description:
        'The **brightness** of the photo prevents us from reading the information correctly. Please start again, paying particular attention to its **readability**, to the **reflections** and to the fact that the photo is taken **in a luminous space**.',
      label: 'ID document quality: Too dark',
    },
    ID_INCOHERENT: {
      description:
        "the information on your document doesn't match the info you provided (birthday, birthplace, nationality, name)",
      label: 'ID incoherent',
    },
    INCOMPLETE: {
      description:
        'Some pages are missing: please provide use with the complete document.',
      label: 'Incomplete',
    },
    JDD_INCOHERENT: {
      description:
        'the address or name on your proof of address does not match the information you provided when signing up',
      label: 'Proof of address incoherent',
    },
    JDD_INCOHERENT_NOM: {
      description:
        'The name on your proof of address suggests that you are hosted by someone',
      label: 'Proof of address name incoherent',
    },
    KYB_DRAFT_STATUTES_ACTIVITY_UNCLEAR: {
      description:
        'The main activity written on your draft statutes is not precise enough. Please clarify your activity and send us a new version of the document.',
      label: 'Activity unclear',
    },
    KYB_DRAFT_STATUTES_EDIT_ACCOUNT_HOLDER: {
      description:
        "Your role in the company does not allow you to open a Shine account. Only a shareholder with at least 25% of the company's capital or the chairman or manager can be an account holder. Please contact us if you wish to change your role or send us your updated draft articles of association.",
      label: 'Account holder to be modified ',
    },
    KYB_DRAFT_STATUTES_INCONSISTENT_ADDRESS: {
      description:
        'The address of your company given when you registered does not match the address given on your draft statutes. Please update it by contacting us at depot@shine.fr or send us another draft statutes via your Shine account.',
      label: 'Inconsistent Address',
    },
    KYB_DRAFT_STATUTES_INCONSISTENT_LEGAL_NAME: {
      description:
        'The name of your company does not match the name entered when you registered. Please change this information in your draft statutes and return the updated document. If you would like us to help you, please contact us at depot@shine.fr.',
      label: 'Inconsistent legal name',
    },
    KYB_DRAFT_STATUTES_INCONSISTENT_NAME: {
      description: `The first name/surname of one of the partners entered on your draft Articles of Association does not correspond to the name/surname entered on their identity document. Please correct it and return your updated document.`,
      label: 'Inconsistent name',
    },
    KYB_DRAFT_STATUTES_INCONSISTENT_SHARE_CAPITAL: {
      description:
        'The amount of your share capital does not correspond to the number of shares indicated and their nominal value. As a reminder, share capital is calculated as follows: (total number of shares x nominal value of one share = amount of share capital). Please recalculate your share capital and return your updated document.',
      label: 'Inconsistent share capital',
    },
    KYB_DRAFT_STATUTES_LEGAL_NAME_INCLUDES_NAME: {
      description:
        'Your company name cannot be limited to the first and last names of one of the shareholders. We advise you to incorporate the legal form or remove the first name from the company name. We invite you to edit this information in your draft statutes and to return the updated document.',
      label: 'Refusal risk (names)',
    },
    KYB_DRAFT_STATUTES_MISSING_ADDRESS: {
      description:
        'The postal address of one of your shareholders is missing from your draft statutes. Please add this information and return your updated document.',
      label: 'Missing address',
    },
    KYB_DRAFT_STATUTES_MISSING_ALLOCATION_OF_SHARES: {
      description:
        'The breakdown of shares is missing from your draft statutes. We invite you to add this information to your document and to send it back to us up to date.',
      label: 'Missing allocation of shares',
    },
    KYB_DRAFT_STATUTES_MISSING_APPOINTMENT_DEED: {
      description: `The deed of appointment is missing. We invite you to appoint the Managing Director/Chairman in your draft statutes or to send us the deed of appointment by e-mail to depot@shine.fr.`,
      label: 'Missing appointment deed',
    },
    KYB_DRAFT_STATUTES_MISSING_BIRTH_DATE: {
      description:
        'The date of birth of one of your shareholders is missing from your draft statutes. Please add this information and return your updated document.',
      label: 'Missing birthdate',
    },
    KYB_DRAFT_STATUTES_MISSING_MENTION_APPENDIX: {
      description: `Your draft statutes has an appendix "Etat des actes accomplis au nom de la société en formation avant la signature des statuts". Please add the following text inside :\n\n${DRAFT_STATUTES_MENTIONS.APPENDIX}`,
      label: 'Missing mention in appendix',
    },
    KYB_DRAFT_STATUTES_MISSING_MENTION_APPORTS: {
      description: `For your capital deposit to be taken into account, please add the following text in the "Apports" section of your draft statutes :\n\n${DRAFT_STATUTES_MENTIONS.APPORTS}`,
      label: 'Missing mention in Apports',
    },
    KYB_DRAFT_STATUTES_MISSING_SHAREHOLDERS: {
      description: `Some key people in the company are missing. We invite you to ask all the company's partners and managers to complete their profiles.`,
      label: 'Missing shareholders',
    },
    KYB_DRAFT_STATUTES_MISSING_SHARES: {
      description:
        'The total number of shares or the value of a share is missing from your draft statutes. Please add this information to the Share Capital section of your document and send us an updated version.',
      label: 'Missing shares',
    },
    KYB_DRAFT_STATUTES_NOT_ACCEPTED: {
      description:
        'The document sent is not accepted. Please provide us with your complete draft statutes in PDF format (20MB max.). If you have any questions, you can consult the Company Creation (capitalization of Creation) section of our FAQ or contact us via your Shine account.',
      label: 'Draft statutes not accepted',
    },
    KYB_DRAFT_STATUTES_NOT_AUTHENTICATED: {
      description:
        'The document sent is not fully legible and cannot be reviewed properly. Please return your draft statutes in PDF format without any manual modifications (deletions, annotations, comments, etc.).',
      label: 'Draft Statues not authenticated',
    },
    KYB_DRAFT_STATUTES_NOT_COMPLETE: {
      description:
        'Some pages are missing from the document sent and it cannot be processed as it stands. Please send us your complete draft statutes in PDF format (max. 20 MB).',
      label: 'Draft statutes not complete',
    },
    KYB_DRAFT_STATUTES_OTHER_MENTIONS: {
      description: `The entry in the "Contributions" section of your draft articles of association indicates the name of another notary/bank for your capital deposit. Please replace it with : \n\n${DRAFT_STATUTES_MENTIONS.APPORTS}`,
      label: 'Other mentions in draft statutes',
    },
    KYB_DRAFT_STATUTES_OTHER_MENTIONS_APPENDIX: {
      description: `The entry in the "Statement of acts performed on behalf of the company in formation prior to signature of the articles of association" section of your document indicates the name of another bank for your account opening. Please replace it with :\n\n${DRAFT_STATUTES_MENTIONS.APPENDIX}`,
      label: 'Other mentions in appendix',
    },
    KYB_DRAFT_STATUTES_SHAREHOLDER_INCONSISTENT_ADDRESS: {
      description:
        'The postal address of one of your shareholders does not correspond to the address entered when registering. Please check that the information on your draft statutes is correct and return your updated document.',
      label: 'Inconsistent shareholder address',
    },
    KYB_DRAFT_STATUTES_SHAREHOLDER_INCONSISTENT_BIRTHDATE: {
      description:
        'The date of birth of one of your shareholders does not match the date entered when registering. Please check that the information on your draft statutes is correct and return your updated document.',
      label: 'Inconsistent shareholder birthdate',
    },
    KYB_DRAFT_STATUTES_SHARES_INCONSISTENT: {
      description:
        'The breakdown of shares in your draft statutes is incorrect. Please check that the sum of the shares of each shareholder is equal to the amount of the share capital to be paid up. The breakdown of shares must be shown on your document.',
      label: 'Inconsistent shares',
    },
    KYB_DRAFT_STATUTES_UNCLEAR_ACTIVITY: {
      description:
        "We need to know more about your company's activities. The information we have is not complete enough. Please contact us at domicile@shine.fr and give us as many details as possible (types of products sold or services offered, website, etc).",
      label: 'Unclear activity',
    },
    KYB_DRAFT_STATUTES_VARIABLE_CAPITAL: {
      description: `The minimum and/or maximum amount of your variable capital is missing. Please add this information to the relevant article of your draft statutes.`,
      label: 'Variable capital missing',
    },
    KYB_DRAFT_STATUTES_VARIABLE_CAPITAL_INCONSISTENT: {
      description: `The percentage of paid-up capital given at the time of your registration does not correspond to the percentage given in your draft statutes. Please check the percentage paid up and/or specify the amount paid up per partner.`,
      label: 'Inconsistent variable capital',
    },
    KYB_INCONSISTENT_ADDRESS: {
      description:
        'The business address you entered does not appear to match the address on the document. Please contact us to update it or upload another document.',
      label: 'Inconsistent address',
    },
    KYB_INCONSISTENT_NAME: {
      description:
        'The company name you have entered does not appear to correspond to the name on the document. Please contact us to update it or send us another document.',
      label: 'Inconsistent name',
    },
    KYB_INCONSISTENT_SIREN: {
      description:
        'The SIREN number you entered does not seem to match this document. Please send us a new document or contact us so that we can update your file if there is an error on the number.',
      label: 'Inconsistent SIREN',
    },
    KYB_INCONSISTENT_SIRET: {
      description:
        'The SIRET number you entered does not seem to match this document. Please send us a new document or contact us so that we can update your file if there is an error on the number.',
      label: 'Inconsistent SIRET',
    },
    KYB_INPI_INCONSISTENT_LEGAL_FORM: {
      description:
        'The legal form filled in your file does not seem to match the one listed on the document. We invite you to contact us to update it or to send us another document.',
      label: 'Incorrect legal form',
    },
    KYB_KBIS_EXPIRED: {
      description:
        'The document you sent us does not seem up to date. Please provide us with a less than three months old document.',
      label: 'KBIS expired',
    },
    KYB_KBIS_INCONSISTENT_SIRET: {
      description:
        'The SIRET number is not present on your document. Could you please send us an “avis de situation au répertoire Sirene” dated less than three months (PDF format)?',
      label: 'KBIS inconsistent siret',
    },
    KYB_MANDATE_INCONSISTENT_COMPANY: {
      description:
        'The mandate must mention your client’s company. Please add the company’s legal name and provide us with the updated document.',
      label: 'Inconsistent company mention',
    },
    KYB_MANDATE_INCONSISTENT_CONTRACTOR: {
      description:
        'The mandate must designate the legal representative of the company as the contractor. Please add the missing mention and provide us with the updated document.',
      label: 'Inconsistent designated contractor',
    },
    KYB_MANDATE_INCONSISTENT_MANDATEE: {
      description:
        'The mandate must designate yourself as the mandatee. Please add the missing mention and provide us with the updated document.',
      label: 'Inconsistent designated mandatee',
    },
    KYB_MANDATE_MISSING_MENTION_POWER: {
      description:
        'The mandate must stipulate that you have the power to initiate the capital deposit and open a bank account.',
      label: 'Missing power mention',
    },
    KYB_NOT_UP_TO_DATE: {
      description:
        'The document you sent us does not seem to be up to date. Could you please send us an “Avis de situation au répertoire Sirene” of less than three months (PDF format)?',
      label: 'Document not up to date',
    },
    KYB_REGISTRATION_DOC_NOT_SUPPORTED: {
      description:
        'We cannot accept this document. Could you please send us an “Avis de situation au répertoire Sirene” of less than three months (PDF format)?',
      label: 'KYB registration doc not supported',
    },
    KYB_STATUTES_BENEFICIARY_MISSING: {
      description: `The list of beneficiaries declared when you registered is incomplete. Add all directors and shareholders with more than 25% of the company's shares.`,
      label: 'Beneficiary missing',
    },
    KYB_STATUTES_DOC_NOT_SUPPORTED: {
      description:
        'The document sent is not accepted. Send us the latest version of the statutes filed and registered with the Greffe.',
      label: 'Document not supported statutes',
    },
    KYB_STATUTES_INCOMPLETE: {
      description:
        'Some pages are missing. Could you please provide us with the last complete version of your “statuts” from the “Greffe”?',
      label: 'Statutes incomplete document',
    },
    KYB_STATUTES_NOT_AUTHENTICATED: {
      description:
        'The document sent is not fully legible and cannot be reviewed properly. Please return your statutes in PDF format without any manual modifications (deletions, annotations, comments, etc.).',
      label: 'Statutes not authenticated',
    },
    KYB_STATUTES_NOT_COMPLETE: {
      description:
        'Some pages are missing from the document sent and it cannot be processed as it stands. Please send us your complete statutes in PDF format (max. 20 MB).',
      label: 'Incomplete',
    },
    KYB_STATUTES_NOT_UP_TO_DATE: {
      description:
        'Your statutes are not up to date. Send us the latest version of the statutes filed and registered with the Greffe.',
      label: 'Statutes not up-to-date',
    },
    KYB_STATUTES_REMOVE_BENEFICIARY: {
      description:
        'Some partners do not own at least 25% of the shares in the company and are not listed as directors. As a result, we cannot add them as beneficiaries. Please contact us to remove their profile.',
      label: 'Delete invalid beneficiary',
    },
    KYB_STATUTES_SIGNATURE_MISSING: {
      description:
        'The statutes must be signed. Send us the latest version of the statutes filed and registered with the Greffe.',
      label: 'Statutes not signed',
    },
    KYB_STATUTES_SUBSCRIBERS_LIST_MISSING: {
      description:
        'Please provide us with the list of subscribers in addition to your statutes.',
      label: 'Statutes subscribers missing',
    },
    KYB_STATUTES_WRONG_ACCOUNT_HOLDER: {
      description:
        'It would appear from your documents that you are not the company director. Contact us from your Shine account or at domicile@shine.fr so that we can assign the role of Shine account holder to the company director.',
      label: 'Wrong account holder',
    },
    KYB_UNCLEAR_ACTIVITY: {
      description:
        'We need to know more about your company‘s business. The information we have is not complete enough. We invite you to contact us on the email address domicile@shine.fr and give us as many details as possible (type of products, website, etc).',
      label: 'Unclear activity',
    },
    KYC_BIRTH_PLACE_INCONSISTENT: {
      description:
        'The information in the document does not match the information you entered when registering (place of birth). Please update your account information or provide another document.',
      label: 'Birth place inconsistent',
    },
    KYC_DRIVING_LICENCE_NOT_SUPPORTED: {
      description:
        "We **do not accept a driver's license** as identification. Please take a photo of your passport or identity card.",
      label: 'Driving licence not supported',
    },
    KYC_HOST_INCONSISTENT_NAME: {
      description:
        'The first and last names on the document **do not match those of your host**. The data on their identity document, the certificate of accommodation and the proof of address must match.',
      label: 'Host inconsistent name',
    },
    KYC_ID_ASSISTED_DOCUMENT_PHOTO: {
      description:
        'We are having difficulties establishing a **match between your ID and the video taken**. We invite you to repeat the identity verification step, making sure that your face is clearly visible and that you are the only person in the video.',
      label: 'Assisted document photo',
    },
    KYC_ID_ASSISTED_SELFIE: {
      description:
        'We are having difficulties establishing a **match between your ID and the video taken**. We invite you to repeat the identity verification step, making sure that your face is clearly visible and that you are the only person in the video.',
      label: 'Assisted selfie',
    },
    KYC_ID_ASSISTED_VIDEO: {
      description:
        'We are having difficulties establishing a **match between your ID and the video taken**. We invite you to repeat the identity verification step, making sure that your face is clearly visible and that you are the only person in the video.',
      label: 'Assisted video',
    },
    KYC_ID_DATE_OF_BIRTH_DOES_NOT_MATCH: {
      description:
        'The date of birth shown on your ID does not match the information entered when you registered. We invite you to repeat the identity verification step to finalise your registration.',
      label: 'Date of birth does not match client input.',
    },
    KYC_ID_DATE_OF_BIRTH_DOES_NOT_MATCH_PREVIOUS_ID: {
      description:
        'The date of birth shown on your identity document does not match the identity document sent previously. We invite you to repeat the identity verification step to finalise your registration.',
      label: 'Date of birth does not match previous ID document',
    },
    KYC_ID_DOCUMENT_CONDITION_INSUFFICIENT: {
      description:
        'The condition of your document does not allow us to verify its authenticity. We invite you to repeat the identity verification step, making sure that you send us another valid identity document.',
      label: 'Document condition insufficient',
    },
    KYC_ID_ERROR_OTHER_DOCUMENT: {
      description:
        'We are having difficulties establishing a **match between your ID and the video taken**. We invite you to repeat the identity verification step, making sure that your your face is well lit and is not in shadow, fully visible and that you are not wearing glasses.',
      label: 'ID document quality: Other',
    },
    KYC_ID_ERROR_OTHER_SELFIE: {
      description:
        'We are having difficulties establishing a **match between your ID and the video taken**. We invite you to repeat the identity verification step, making sure that your your face is well lit and is not in shadow, fully visible and that you are not wearing glasses.',
      label: 'Selfie quality: Other',
    },
    KYC_ID_ERROR_OTHER_VIDEO: {
      description:
        'We are having difficulties establishing a **match between your ID and the video taken**. We invite you to repeat the identity verification step, making sure that your your face is well lit and is not in shadow, fully visible and that you are not wearing glasses.',
      label: 'Video quality: Other',
    },
    KYC_ID_EXPIRED: {
      description:
        'The identity document has **expired**. We invite you to repeat the identity verification step, making sure that you send us another valid identity docuement (identity card, passport or European residence permit). Driving licences are not accepted.',
      label: 'Expired document',
    },
    KYC_ID_EXPIRY_DATE_DOES_NOT_MATCH: {
      description:
        'The information on your ID does not match the information entered when you registered. We invite you to repeat the identity verification step to finalise your registration.',
      label: 'Expiry date does not match client input.',
    },
    KYC_ID_GDPR_BREACH: {
      description:
        "We are having difficulties establishing a **match between your ID and the video taken**. We invite you to repeat the identity verification step, making sure you have your own ID and not someone else's.",
      label: 'Document quality: GDPR breach',
    },
    KYC_ID_GDPR_BREACH_SELFIE: {
      description:
        'We are having difficulties establishing a **match between your ID and the video taken**. We invite you to repeat the identity verification step, making sure that your face is clearly visible and that you are the only person in the video.',
      label: 'Selfie quality: GDPR breach',
    },
    KYC_ID_GDPR_BREACH_VIDEO: {
      description:
        'We are having difficulties establishing a **match between your ID and the video taken**. We invite you to repeat the identity verification step, making sure that your face is clearly visible and that you are the only person in the video.',
      label: 'Video quality: GDPR breach',
    },
    KYC_ID_INADEQUATE_SELFIE: {
      description:
        'The video quality is not sufficient to verify your identity. We invite you to repeat the identity verification step, making sure that your your face is well lit and is not in shadow, fully visible and that you are not wearing glasses.',
      label: 'Inadequate selfie',
    },
    KYC_ID_INADEQUATE_VIDEO: {
      description:
        'The content of the video taken is inappropriate. We invite you to repeat the identity verification step to finalise your registration.',
      label: 'Inadequate video',
    },
    KYC_ID_INCONSISTENT_NAME: {
      description:
        'The **first name/last name** that you have filled in **does not match the one on this ID**. Please download a new document or contact us so that we can update your file.',
      label: 'Inconsistent name',
    },
    KYC_ID_INCONSISTENT_SELFIE: {
      description:
        'We are having difficulty **matching your ID to the video taken**. Please start again by making sure that your face is clearly visible.',
      label: 'Inconsistent selfie',
    },
    KYC_ID_INCONSISTENT_SELFIE_FACE_NOT_VISIBLE: {
      description:
        'We are having difficulties establishing a **match between your ID and the video taken**. We invite you to repeat the identity verification step, making sure that your your face is well lit and is not in shadow, fully visible and that you are not wearing glasses.',
      label: 'Face not fully visible or within frame.',
    },
    KYC_ID_INCONSISTENT_SELFIE_NOT_SAME_PERSON: {
      description:
        'We are having difficulties establishing a **match between your ID and the video taken**. We invite you to repeat the identity verification step, making sure that your your face is well lit and is not in shadow, fully visible and that you are not wearing glasses.',
      label: 'Not the same person.',
    },
    KYC_ID_INCONSISTENT_SELFIE_TOO_BLURRY: {
      description:
        'We are having difficulty **matching your ID to the video taken**. Please start again by making sure that your face is clearly visible.',
      label: 'Selfie quality: Too blurry',
    },
    KYC_ID_INCONSISTENT_SELFIE_TOO_BRIGHT: {
      description:
        'We are having difficulty **matching your ID to the video taken**. Please start again by making sure that your face is clearly visible.',
      label: 'Selfie quality: Too bright',
    },
    KYC_ID_INCONSISTENT_SELFIE_TOO_DARK: {
      description:
        'We are having difficulty **matching your ID to the video taken**. Please start again by making sure that your face is clearly visible.',
      label: 'Selfie quality: Too dark',
    },
    KYC_ID_INCONSISTENT_VIDEO_TOO_BLURRY: {
      description:
        'We are having difficulty **matching your ID to the video taken**. We invite you to repeat the identity verification step, making sure that your face is clearly visible.',
      label: 'Video quality: Too blurry',
    },
    KYC_ID_INCONSISTENT_VIDEO_TOO_BRIGHT: {
      description:
        'We are having difficulty **matching your ID to the video taken**. We invite you to repeat the identity verification step, making sure that your face is clearly visible.',
      label: 'Video quality: Too bright',
    },
    KYC_ID_INCONSISTENT_VIDEO_TOO_DARK: {
      description:
        'We are having difficulty **matching your ID to the video taken**. We invite you to repeat the identity verification step, making sure that your face is clearly visible.',
      label: 'Video quality: Too dark',
    },
    KYC_ID_INVERTED: {
      description:
        'The recto and the verso of your ID are inverted. Please send first the front of your ID, and the the back of it.',
      label: 'ID recto/verso inverted',
    },
    KYC_ID_ISSUE_DATE_DOES_NOT_MATCH: {
      description:
        'The information on your ID does not match the information entered when you registered. We invite you to repeat the identity verification step to finalise your registration.',
      label: 'Issue date does not match client input.',
    },
    KYC_ID_KYC_GENDER_DOES_NOT_MATCH: {
      description:
        'The legal gender shown on your ID does not match the information entered when you registered. We invite you to repeat the identity verification step, making sure that the gender you have selected matches the gender on your identity document or contact us at the following address: domicile@shine.fr so that we can update your file.',
      label: 'Gender does not match client input.',
    },
    KYC_ID_KYC_INVALID_ID_DOCUMENT: {
      description:
        'The ID sent does not correspond to the type of document you selected when you registered. We invite you to repeat the identity verification step, making sure you select the correct type of document to send.',
      label: 'Invalid ID document',
    },
    KYC_ID_LIVENESS_FEATURE: {
      description:
        'The video quality is not sufficient to verify your identity. We invite you to repeat the identity verification step, making sure that your your face is well lit and is not in shadow, fully visible and that you are not wearing glasses.',
      label: 'Liveness features not visible',
    },
    KYC_ID_NAME_DOES_NOT_MATCH_PREVIOUS_ID: {
      description:
        'The first/last name shown on your identity document does not match the identity document sent previously. We invite you to repeat the identity verification step to finalise your registration.',
      label: 'Name in client input does not match ID document',
    },
    KYC_ID_NAME_FIELDS_DOES_NOT_MATCH: {
      description:
        'The last/first name on your ID does not match the information entered when you registered. We invite you to repeat the identity verification step to finalise your registration.',
      label: 'Name fields do not match client input: Full legal name',
    },
    KYC_ID_NATIONALITY_DOES_NOT_MATCH: {
      description:
        'The nationality shown on your ID does not match the information entered when you registered. We invite you to repeat the identity verification step to finalise your registration.',
      label: 'Nationality does not match client input.',
    },
    KYC_ID_NUMBER_DOES_NOT_MATCH: {
      description:
        'The information on your ID does not match the information entered when you registered. We invite you to repeat the identity verification step to finalise your registration.',
      label: 'Document number does not match client input.',
    },
    KYC_ID_PHOTO_BLOCKED: {
      description:
        'The identity document sent is partially hidden. We invite you to repeat the identity verification step, making sure that all the information is legible. Screenshots, photos, photocopies and scans are not accepted.',
      label: 'Photo blocked',
    },
    KYC_ID_PLACE_OF_BIRTH_DOES_NOT_MATCH: {
      description:
        'The place of birth shown on your ID does not match the information entered when you registered. We invite you to repeat the identity verification step to finalise your registration.',
      label: 'Place of birth does not match client input.',
    },
    KYC_ID_PLACE_OF_BIRTH_DOES_NOT_MATCH_PREVIOUS_ID: {
      description:
        'The place of birth shown on your identity document does not match the identity document sent previously. We invite you to repeat the identity verification step to finalise your registration.',
      label: 'Place of birth does not match previous ID document',
    },
    KYC_ID_PLASTIC_COVER: {
      description:
        'The plastic cover on your ID does not allow us to verify its authenticity. We invite you to repeat the identity verification step, making sure to send us a photo of your identity document without its plastic cover.',
      label: 'Document is inside a plastic cover.',
    },
    KYC_ID_RECTO_VERSO_MISSING: {
      description:
        'One side of your ID is missing. Please try again and provide us with the **front and the back**.',
      label: 'ID recto/verso missing',
    },
    KYC_MISSING_SELFIE: {
      description:
        'An error occurred with your ID. Please download the latest version of the Shine mobile app and try again.',
      label: 'Missing selfie',
    },
    KYC_PASSPORT_HOST_PAGE_MISSING: {
      description:
        'Could you take a photo of your host’s passport with the **signature page** in a bright, glare-free room?',
      label: 'Second page missing',
    },
    KYC_PASSPORT_NON_EUROPEAN: {
      description:
        'We cannot accept a non european passeport. Please send us your residence permit.',
      label: 'Non european passport',
    },
    KYC_PASSPORT_SECOND_PAGE_MISSING: {
      description:
        'The **two parts of your passport** are necessary for us to validate it. Please take a photo of the two pages (the one with your signature and the one with your photo) of your document (original version), paying particular attention to its legibility, reflections and brightness.',
      label: 'Passport second page missing',
    },
    KYC_POA_4G_BOX: {
      description: 'We don’t accept invoices for 4G boxes.',
      label: '4G box',
    },
    KYC_POA_COMPANY_NAME: {
      description:
        "We do not accept **proof of address in the name of your company**. This document allows us to justify your personal address, not your company's. Please send us a new document on your name.",
      label: 'Proof of address in company name',
    },
    KYC_POA_ENDED_INVOICE: {
      description:
        'We cannot accept an invoice that has been ended. Please provide us with a new proof of address.',
      label: 'Ended invoice',
    },
    KYC_POA_EXPIRED: {
      description:
        'The proof of address that you have sent us is no longer valid: it is **expired**. We need a document **dated less than 3 months**.',
      label: 'Proof of address expired',
    },
    KYC_POA_FIRSTNAME_MISSING: {
      description: 'The first name must be present on the proof of address.',
      label: 'Proof of address firstname missing',
    },
    KYC_POA_INCONSISTENT_ADDRESS: {
      description:
        'The address on the document does not match the address you entered when you registered. Please contact us to modify it or send us another proof of address with your **personal address** written on it.',
      label: 'Proof of address inconsistent address',
    },
    KYC_POA_INCONSISTENT_NAME: {
      description:
        'The first and last names do not match those on file. If you are hosted, you must tick "I am hosted" when adding your proof of address, and send us a document with the full name of your host.',
      label: 'Proof of address inconsistent name',
    },
    KYC_POA_MOBILE: {
      description: 'We don’t accept invoices from mobile operators.',
      label: 'Mobile invoice',
    },
    KYC_POA_NAME_SLIGHTLY_DIFFERENT: {
      description:
        'The first and last name on the proof of address must be **identical to the ID**, please contact your provider to make the change on your document.',
      label: 'Name slightly different',
    },
    KYC_POA_NO_CONTROL_POINT: {
      description:
        'We cannot assert the authenticity of the document. Could you send us another proof of address?',
      label: 'No control point',
    },
    KYC_POA_NOT_SUPPORTED: {
      description:
        'This proof of address **is not accepted**. We would need either an **internet, landline or energy bill** (water, gas or electricity) of **less than 3 months**, or your **last tax notice** on income, housing tax or property tax, or a **certificate of contract** energy, water or telecoms (must include a 2D-DOC barcode).',
      label: 'Proof of address not supported',
    },
    KYC_POA_PAYMENT_SCHEDULE: {
      description:
        'Please ask for a certificate of contract, we cannot accept a payment schedule.',
      label: 'Payment schedule',
    },
    KYC_POA_PLACE_OF_CONSUMPTION_ADDRESS: {
      description:
        'The address of the **place of consumption is different from the postal address**. We cannot accept your document since only the postal address counts. Please send us another proof of address to your address (internet or landline bill for example).',
      label: 'Proof of address place of consumption',
    },
    KYC_POA_PRINTED: {
      description:
        'Please provide us with the full and official PDF version of the document, directly downloaded frm your provider website.',
      label: 'POA printed',
    },
    KYC_POA_SCREENSHOT: {
      description:
        'Les captures d’écrans ne sont pas acceptées. Merci de nous fournir la version officielle et complète au format pdf s’il vous plaît (téléchargée directement depuis le site de votre fournisseur).',
      label: 'POA screenshot',
    },
    KYC_POA_UNPAID_INVOICE: {
      description:
        'We cannot accept an invoice with unpaid amount. Please provide us with a new proof of address.',
      label: 'Unpaid invoice',
    },
    KYC_PROOF_OF_ACCOMMODATION_ESIGNATURE: {
      description:
        'We **cannot accept digital signatures**. We invite you to print the certificate and have it signed by your host. You will then be able to take a picture of it and send it to us.',
      label: 'Proof of accomodation e-signature',
    },
    KYC_PROOF_OF_ACCOMMODATION_EXPIRED: {
      description:
        'The certificate of accommodation is no longer valid: it is **expired**. We need a document **dated less than 3 months** and signed by your host.',
      label: 'Proof of accommodation expired',
    },
    KYC_PROOF_OF_ACCOMMODATION_HOST_BIRTHDATE_MISMATCH: {
      description:
        'Could you please correct the date of birth of your host on the accommodation certificate so that it is identical to their identity document?',
      label: 'Proof of accomodation host birthdate',
    },
    KYC_PROOF_OF_ACCOMMODATION_INCONSISTENT_ADDRESS: {
      description:
        'The address on the document does not match the address you entered when you registered. Please contact us to modify it or send us another proof of accommodation with your **personal address** written on it.',
      label: 'Inconsistent address',
    },
    KYC_PROOF_OF_ACCOMMODATION_INCONSISTENT_SIGNATURE: {
      description:
        "The **signature must be identical** to the one on your host's ID.",
      label: 'Proof of accomodation: signature different',
    },
    KYC_PROOF_OF_ACCOMMODATION_NAME_SLIGHTLY_DIFFERENT: {
      description:
        'The first and last name on the proof of address must be **identical to the ID**, please contact your provider to make the change on your document.',
      label: 'Name slightly different',
    },
    KYC_PROOF_OF_ACCOMMODATION_SIGNATURE_MISSING: {
      description:
        'The **signature of your host is missing** on the certificate. We would ask you to print it out and have it signed (handwritten signature) by your host, before sending it back to us. Please note that the signature must be the same as the one on his identity card.',
      label: 'Proof of accomodation signature missing',
    },
    KYC_PROOF_OF_ACCOMMODATION_USER_BIRTHDATE_MISMATCH: {
      description:
        'Could you please correct your date of birth on the accommodation certificate so that it is identical to your identity document?',
      label: 'Proof of accomodation user birthdate',
    },
    KYC_RESIDENCE_PERMIT_HOST_MISSING: {
      description:
        'Could you send us your host’s residence permit via the application and their récépissé by email to the following address: domicile@shine.fr?',
      label: 'Host residence permit missing',
    },
    KYC_RESIDENCE_PERMIT_MISSING: {
      description:
        'Could you submit your residence permit via the application and send your récépissé by e-mail to the following address: domicile@shine.fr?',
      label: 'Residence permit missing',
    },
    KYC_SHINE_START_POA_MENTION_MICRO_MISSING: {
      description:
        'Please ask your host to **add** the following sentence: **Certifie sur l’honneur que j’autorise l’hébergé(e) ci-dessous à domicilier sa micro-entreprise à mon domicile mentionné ci-dessus**.',
      label: 'Hosting micro-company missing (Shine Start)',
    },
    KYC_SHINE_START_POA_NOT_SUPPORTED: {
      description:
        'This proof of address **is not accepted**. We would need either an **internet, landline telephone or energy bill** (water, gas or electricity) of **less than 3 months**, or a **attestation of contract** energy, water or telecom (must include a 2D-DOC barcode).',
      label: 'Unsupported proof of address (Shine Start)',
    },
    KYC_SHINE_START_RESIDENCE_PERMIT_HOST_INCONSISTENT_ADDRESS: {
      description:
        'The address indicated on your host residence permit is **different from that indicated on the proof of residence**. Please request a change of address for the residence permit, otherwise the State may refuse your application to create a company.',
      label: 'Inconsistent host address (Shine Start)',
    },
    KYC_SHINE_START_RESIDENCE_PERMIT_INCONSISTENT_ADDRESS: {
      description:
        'The address indicated on the residence permit is **different from that indicated on the proof of residence**. Please request a change of address for the residence permit, otherwise the State may refuse your application to create a company.',
      label: 'Address inconsistent (Shine Start)',
    },
    MISSING: {
      description:
        'this document is required in order to complete your registration',
      label: 'Missing',
    },
    NEED_ANOTHER: {
      description: 'please provide another document',
      label: 'Need another',
    },
    NO_DATE: {
      description:
        'document has to be dated (and be no more than 3 months old)',
      label: 'No date',
    },
    NO_SIGNATURE: {
      description: 'signature is not visible on this document',
      label: 'No signature',
    },
    NOT_AUTHENTICATED: {
      description:
        'The quality of the photo does not allow us to verify the authenticity of the document. All the information must be readable. Could you please send us a clear picture of your document? Screenshots, photos, photocopies and scans are not supported.',
      label: 'Not authenticated',
    },
    OUT_OF_BOUNDS: {
      description:
        "you can't open a Shine account with this ID document. Please provide a residence permit.",
      label: 'Residence permit required',
    },
    PHOTOCOPY: {
      description:
        'Photocopies and scans are not accepted. We invite you to repeat the identity verification step to finalise your registration.',
      label: 'Photocopy',
    },
    SCAN: {
      description:
        'Please send us a photograph of the document instead of a scan.',
      label: 'Scanned doc',
    },
    SCREEN: {
      description:
        'Screen, scan or photocopy photos are not accepted. You must have the **original document** at the time you take your photo.',
      label: 'Screen photograph/Photocopy',
    },
    SCREENSHOT: {
      description:
        'Screenshots are not accepted. Could you please submit a photo of the document, or the document in original PDF format?',
      label: 'Screenshot',
    },
    TYPE_NOT_SUPPORTED: {
      description:
        'this document type is not part of the list of supported documents',
      label: 'Document not supported',
    },
    UNREADABLE: {
      description:
        "we couldn't verify the authenticity of the document. Make sure all the information is readable",
      label: 'Unreadable',
    },
    UPLOAD_ERROR: {
      description:
        'An error has occurred while downloading the document and it cannot be opened. Please try again by adding a document in PDF format (20 MB max.). We apologise for any inconvenience caused.',
      label: 'Upload error',
    },
  },

  fr: {
    BLACK_AND_WHITE: {
      description:
        "Le document que vous nous avez transmis ne peut pas être en noir et blanc. Les captures d'écran, photos de photocopie et photos d'écran ne sont pas supportées. Merci de fournir la photo de votre document original s’il vous plaît.",
      label: 'Noir et blanc',
    },
    BLURRY: {
      description:
        "Votre document n’a pas été validé car la photo est floue. Toutes les informations doivent être lisibles. Merci de nous renvoyer une photo bien nette du document s’il vous plaît. Les captures d'écran et photos d'écran ne sont pas supportées.",
      label: 'Flou',
    },
    BRIGHTNESS: {
      description:
        'La **luminosité** de la photo nous empêche de lire correctement les informations. Nous vous invitons à recommencer en portant une attention particulière à sa **lisibilité**, aux **reflets** et à ce que la prise de photo soit faite **dans un espace lumineux**.',
      label: 'Problème de luminosité',
    },
    CROPPED: {
      description:
        "La photo de votre pièce d’identité est rognée (coupée). Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant de nous transmettre une photo complète de votre pièce d'identité dans le cadre, bordures visibles.",
      label: 'Rogné',
    },
    EXPIRED: {
      description:
        'Le document que vous avez fourni est expiré ou date de plus de 3 mois. Merci de nous transmettre un document plus récent s’il vous plaît.',
      label: 'Expiré',
    },
    FALSIFIED: {
      description:
        'Nous n’avons pas pu vérifier l’authenticité du document fourni. Merci de nous en fournir un nouveau.',
      label: 'Falsifié',
    },
    ID_DOCUMENT_SECURITY_INVISIBLE: {
      description:
        "La **qualité** de la photo nous empêche d'analyser correctement votre document d'identité. Nous vous invitons à recommencer l'étape de vérification d'identité en portant une attention particulière à sa **lisibilité**, aux **reflets** et à ce que la prise de photo soit faite **dans un espace lumineux**.",
      label: 'ID : éléments de sécurité non visibles',
    },
    ID_DOCUMENT_TOO_BRIGHT: {
      description:
        'La **luminosité** de la photo nous empêche de lire correctement les informations. Nous vous invitons à recommencer en portant une attention particulière à sa **lisibilité**, aux **reflets** et à ce que la prise de photo soit faite **dans un espace lumineux**.',
      label: 'ID : trop lumineux (problème de luminosité)',
    },
    ID_DOCUMENT_TOO_DARK: {
      description:
        'La **luminosité** de la photo nous empêche de lire correctement les informations. Nous vous invitons à recommencer en portant une attention particulière à sa **lisibilité**, aux **reflets** et à ce que la prise de photo soit faite **dans un espace lumineux**.',
      label: 'ID : trop sombre (problème de luminosité)',
    },
    ID_INCOHERENT: {
      description:
        'Les informations du document ne correspondent pas aux informations que vous avez saisies lors de votre inscription (nom, prénom, date et lieu de naissance, nationalité). Merci de mettre à jour vos informations sur votre compte ou fournir un autre document s’il vous plaît.',
      label: 'ID incohérent',
    },
    INCOMPLETE: {
      description:
        'Des pages sont manquantes : merci de nous fournir le document complet.',
      label: 'Incomplet',
    },
    JDD_INCOHERENT: {
      description:
        'Les informations sur votre justificatif de domicile ne correspondent pas aux informations saisies lors de votre inscription. Merci de fournir un autre justificatif de domicile cohérent de moins de 3 mois s’il vous plaît. Si vous êtes hébergé·e, merci de nous transmettre la copie recto-verso de la pièce d’identité de votre hébergeur et une attestation d’hébergement datée et signée par votre hébergeur.',
      label: 'JDD incohérent',
    },
    JDD_INCOHERENT_NOM: {
      description:
        'Le nom présent sur votre justificatif de domicile laisse entendre que vous êtes hébergé·e. Merci de nous fournir également la copie recto-verso de la pièce d’identité de votre hébergeur et une attestation d’hébergement datée et signée par votre hébergeur.',
      label: 'Nom JDD incohérent',
    },
    KYB_DRAFT_STATUTES_ACTIVITY_UNCLEAR: {
      description:
        'L’activité principale renseignée sur votre projet de statuts n’est pas suffisamment précise. Nous vous invitons à clarifier l’objet social et à nous renvoyer votre document mis à jour.',
      label: 'Objet social pas assez clair',
    },
    KYB_DRAFT_STATUTES_EDIT_ACCOUNT_HOLDER: {
      description:
        "Le rôle que vous exercez dans l'entreprise ne vous permet pas d'ouvrir un compte Shine. Seul·e un·e actionnaire ayant au moins 25 % du capital de l’entreprise ou le ou la président·e ou gérant·e peut être titulaire du compte. Nous vous invitons à nous contacter si vous souhaitez changer de rôle ou nous renvoyer votre projet de statuts mis à jour.",
      label: 'Titulaire du compte à modifier',
    },
    KYB_DRAFT_STATUTES_INCONSISTENT_ADDRESS: {
      description:
        "L’adresse de votre entreprise renseignée lors de votre inscription ne correspond pas à celle inscrite sur votre projet de statuts. Nous vous invitons à la mettre à jour en nous contactant à l'adresse depot@shine.fr ou à nous transmettre un autre projet de statuts via votre compte Shine.",
      label: 'Adresse incohérente',
    },
    KYB_DRAFT_STATUTES_INCONSISTENT_LEGAL_NAME: {
      description:
        "La dénomination sociale de votre entreprise ne correspond pas à celle saisie lors de votre inscription. Nous vous invitons à modifier cette information dans votre projet de statuts et à renvoyer le document mis à jour. Pour un accompagnement dans vos démarches, contactez-nous à l'adresse depot@shine.fr.",
      label: 'Dénomination sociale incohérente',
    },
    KYB_DRAFT_STATUTES_INCONSISTENT_NAME: {
      description: `Le prénom/nom de l'un·e des associé·es inscrit sur votre projet de statuts ne correspond pas à celui inscrit sur son document d'identité. Nous vous invitons à le corriger et à renvoyer votre document mis à jour.`,
      label: 'Nom incohérent',
    },
    KYB_DRAFT_STATUTES_INCONSISTENT_SHARE_CAPITAL: {
      description:
        "La dénomination sociale de votre entreprise ne correspond pas à celle saisie lors de votre inscription. Nous vous invitons à modifier cette information dans votre projet de statuts et à renvoyer le document mis à jour. Pour un accompagnement dans vos démarches, contactez-nous à l'adresse depot@shine.fr.",
      label: 'Capital social incohérent',
    },
    KYB_DRAFT_STATUTES_LEGAL_NAME_INCLUDES_NAME: {
      description:
        "La dénomination sociale de votre entreprise ne peut se limiter au nom et au prénom de l’un des actionnaires. Nous vous conseillons d'intégrer la forme légale ou retirer le prénom de la dénomination sociale. Nous vous invitons à modifier cette information dans votre projet de statuts et à renvoyer le document mis à jour.",
      label: 'Risque de rejet (nom et prénom)',
    },
    KYB_DRAFT_STATUTES_MISSING_ADDRESS: {
      description: `L'adresse postale de l'un•e de vos actionnaires est absente de votre projet de statuts. Nous vous invitons à ajouter cette information et à renvoyer votre document mis à jour.`,
      label: 'Adresse absente',
    },
    KYB_DRAFT_STATUTES_MISSING_ALLOCATION_OF_SHARES: {
      description:
        'La répartition des parts est absente de votre projet de statuts. Nous vous invitons à ajouter cette information sur votre document et à nous le renvoyer à jour.',
      label: 'Répartition des parts absente',
    },
    KYB_DRAFT_STATUTES_MISSING_APPOINTMENT_DEED: {
      description: `L’acte de nomination est manquant. Nous vous invitons à nommer le Gérant/Président dans votre projet de statut ou nous transmettre l'acte de nomination par e-mail à l’adresse depot@shine.fr.`,
      label: 'Acte de nomination manquant ',
    },
    KYB_DRAFT_STATUTES_MISSING_BIRTH_DATE: {
      description:
        "La date de naissance de l'un•e de vos actionnaires est absente de votre projet de statuts. Nous vous invitons à ajouter cette information et à renvoyer votre document mis à jour.",
      label: 'Date naissance absente',
    },
    KYB_DRAFT_STATUTES_MISSING_MENTION_APPENDIX: {
      description: `L’annexe “Etat des actes accomplis au nom de la société en formation avant la signature des statuts” est présente dans votre projet de statuts mais ne contient pas la mention obligatoire suivante :\n\n${DRAFT_STATUTES_MENTIONS.APPENDIX}\n\nNous vous invitons à modifier votre document et à nous le renvoyer à jour.`,
      label: 'Annexe absente',
    },
    KYB_DRAFT_STATUTES_MISSING_MENTION_APPORTS: {
      description: `La mention obligatoire suivante est manquante de votre projet de statuts, veuillez l’ajouter dans la section "Apports" de votre document et nous le renvoyer à jour.\n\n${DRAFT_STATUTES_MENTIONS.APPORTS}`,
      label: 'Mention du notaire absente',
    },
    KYB_DRAFT_STATUTES_MISSING_SHAREHOLDERS: {
      description:
        "Certaines personnes clés de l'entreprise sont manquantes. Nous vous invitons à demander à toutes et tous les associé·es et dirigeant·es de la société à compléter leur profil.",
      label: 'Actionnaires manquants',
    },
    KYB_DRAFT_STATUTES_MISSING_SHARES: {
      description: `Le nombre total de parts ou la valeur d'une part est absente de votre projet de statuts. Nous vous invitons à ajouter cette information dans la partie Capital Social de votre document et à nous le renvoyer à jour.`,
      label: `Nombre ou montant d'une part absents`,
    },
    KYB_DRAFT_STATUTES_NOT_ACCEPTED: {
      description:
        'Le document envoyé ne fait pas partie des documents acceptés. Nous vous invitons à nous fournir votre projet de statuts complet au format PDF (20Mo max.). Si vous avez des questions, vous pouvez consulter la section Création d’entreprise de notre FAQ ou nous contacter depuis votre compte Shine.',
      label: 'Non accepté',
    },
    KYB_DRAFT_STATUTES_NOT_AUTHENTICATED: {
      description:
        'Le document envoyé n’est pas entièrement lisible et ne peut pas être étudié correctement. Nous vous invitons à renvoyer votre projet de statuts au format PDF sans modification manuelle (rature, annotations, commentaires, etc.)',
      label: 'Non authentifiable',
    },
    KYB_DRAFT_STATUTES_NOT_COMPLETE: {
      description:
        'Certaines pages manquent au document envoyé et il ne peut pas être traité en l’état. Nous vous invitons à renvoyer votre projet de statuts complet au format PDF (20 Mo max.).',
      label: 'Incomplet',
    },
    KYB_DRAFT_STATUTES_OTHER_MENTIONS: {
      description: `La mention inscrite dans la section "Apports" de votre projet de statuts indique le nom d'un autre notaire / établissement bancaire pour votre dépôt de capital. Nous vous invitons à la remplacer par : \n\n${DRAFT_STATUTES_MENTIONS.APPORTS}`,
      label: 'Autres mentions présentes',
    },
    KYB_DRAFT_STATUTES_OTHER_MENTIONS_APPENDIX: {
      description: `La mention inscrite dans la section "Etat des actes accomplis au nom de la société en formation avant la signature des statuts" de votre document indiquent le nom d'un autre établissement bancaire pour votre ouverture de compte. Nous vous invitons à la remplacer par : \n\n${DRAFT_STATUTES_MENTIONS.APPENDIX}`,
      label: 'Autres mentions présentes',
    },
    KYB_DRAFT_STATUTES_SHAREHOLDER_INCONSISTENT_ADDRESS: {
      description:
        "L'adresse postale de l'un•e de vos actionnaires ne correspond pas à celle saisie lors de son inscription. Nous vous invitons à vérifier que les informations renseignées sur votre projet de statuts sont exactes et à renvoyer votre document mis à jour.",
      label: 'Adresse actionnaire incohérente',
    },
    KYB_DRAFT_STATUTES_SHAREHOLDER_INCONSISTENT_BIRTHDATE: {
      description:
        "La date de naissance de l'un•e de vos actionnaires ne  correspond pas à celle saisie lors de son inscription. Nous vous invitons à vérifier que les informations renseignées sur votre projet de statuts sont exactes et à renvoyer votre document mis à jour.",
      label: 'Date de naissance actionnaire incohérente',
    },
    KYB_DRAFT_STATUTES_SHARES_INCONSISTENT: {
      description:
        "La répartition des parts sur votre projet de statuts est incorrecte. Nous vous invitons à vérifier que l'addition des parts de chaque actionnaire est bien égal au montant du capital social à libérer. La répartition des parts doit être indiquée sur votre document.",
      label: 'Répartition des parts incohérente',
    },
    KYB_DRAFT_STATUTES_UNCLEAR_ACTIVITY: {
      description: `Nous avons besoin d’en savoir plus sur l’activité exercée par votre entreprise. Les informations que nous avons ne sont pas assez complètes. Nous vous invitons à nous contacter sur l‘adresse mail domicile@shine.fr en nous donnant un maximum de détails (types de produits vendus ou services proposés, site internet, etc).`,
      label: 'Dénomination sociale incohérente',
    },
    KYB_DRAFT_STATUTES_VARIABLE_CAPITAL: {
      description:
        'Le montant minimum et/ou maximum de votre capital variable est manquant. Nous vous invitons à ajouter cette information dans l’article correspondant de votre projet de statuts.',
      label: 'Capital variable manquant',
    },
    KYB_DRAFT_STATUTES_VARIABLE_CAPITAL_INCONSISTENT: {
      description:
        'Le pourcentage du capital libéré renseignée lors de votre inscription ne correspond pas à celui inscrit sur votre projet de statuts. Nous vous invitons à vérifier le pourcentage de libération et/ou à préciser le montant libéré par associé·e.',
      label: 'Pourcentage de capital libéré incohérent',
    },
    KYB_INCONSISTENT_ADDRESS: {
      description:
        'L’adresse de l’entreprise que vous avez renseignée ne semble pas correspondre à celle inscrite sur le document. Nous vous invitons à nous contacter pour la mettre à jour ou à nous transmettre un autre document.',
      label: 'Adresse de l’entreprise incohérente',
    },
    KYB_INCONSISTENT_NAME: {
      description:
        'Le nom de l’entreprise que vous avez renseigné ne semble pas correspondre à celui inscrit sur le document. Nous vous invitons à nous contacter pour le mettre à jour ou à nous transmettre un autre document.',
      label: 'Nom de l’entreprise incohérent',
    },
    KYB_INCONSISTENT_SIREN: {
      description:
        'Le numéro de SIREN que vous avez renseigné ne semble pas correspondre à ce document. Nous vous invitons à nous envoyer un nouveau document ou à nous contacter pour que nous mettions à jour votre dossier s’il y a une erreur sur le numéro.',
      label: 'SIREN incohérent',
    },
    KYB_INCONSISTENT_SIRET: {
      description:
        'Le numéro de SIRET que vous avez renseigné ne semble pas correspondre à ce document. Nous vous invitons à nous envoyer un nouveau document ou à nous contacter pour que nous mettions à jour votre dossier s’il y a une erreur sur le numéro.',
      label: 'SIRET incohérent',
    },
    KYB_INPI_INCONSISTENT_LEGAL_FORM: {
      description:
        'La forme juridique que vous avez renseignée ne semble pas correspondre à celle inscrite sur le document. Nous vous invitons à nous contacter pour la mettre à jour ou à nous transmettre un autre document.',
      label: 'Forme légale incorrecte',
    },
    KYB_KBIS_EXPIRED: {
      description:
        'Le document que vous nous avez envoyé ne semble pas être à jour. Nous vous invitons à nous envoyer un document de moins de trois mois pour que nous puissions vérifier votre dossier.',
      label: 'KBIS expiré',
    },
    KYB_KBIS_INCONSISTENT_SIRET: {
      description:
        'Le numéro de SIRET n’est pas présent sur votre document. Pouvez-vous s‘il vous plaît nous transmettre un avis de situation au répertoire Sirene daté de moins de trois mois (format PDF) ?',
      label: 'KBIS siret inconsistent',
    },
    KYB_MANDATE_INCONSISTENT_COMPANY: {
      description:
        'Le mandat doit mentionner le nom de l’entreprise de votre client. Nous vous invitons à nous renvoyer le document une fois mis à jour.',
      label: 'Entreprise mentionnée incohérente',
    },
    KYB_MANDATE_INCONSISTENT_CONTRACTOR: {
      description:
        'Le mandat doit désigner le•la représentant•e légal•e de l’entreprise en tant que contracteur. Nous vous invitons à nous renvoyer le document une fois mis à jour.',
      label: 'Contracteur désigné incohérente',
    },
    KYB_MANDATE_INCONSISTENT_MANDATEE: {
      description:
        'Le mandat doit vous désigner personnellement en tant que mandataire. Nous vous invitons à nous renvoyer le document une fois mis à jour.',
      label: 'Mandataire désigné incohérent',
    },
    KYB_MANDATE_MISSING_MENTION_POWER: {
      description:
        'Le mandat doit obligatoirement stipuler que vous avez le pouvoir pour initier le dépôt de capital et ouvrir un compte bancaire.',
      label: 'Mention de pouvoir manquante',
    },
    KYB_NOT_UP_TO_DATE: {
      description:
        'Le document que vous nous avez envoyé ne semble pas être à jour. Pouvez-vous s‘il vous plaît nous transmettre un avis de situation au répertoire Sirene daté de moins de trois mois (format PDF) ?',
      label: 'Document pas assez récent',
    },
    KYB_REGISTRATION_DOC_NOT_SUPPORTED: {
      description:
        'Nous ne pouvons pas accepter ce document. Pouvez-vous s‘il vous plaît nous transmettre un avis de situation au répertoire Sirene daté de moins de trois mois (format PDF) ?',
      label: 'KYB mauvais doc immatriculation',
    },
    KYB_STATUTES_BENEFICIARY_MISSING: {
      description: `La liste des bénéficiaires effectifs déclaré lors de votre inscription est incomplète. Ajoutez tous les dirigeants et actionnaires avec plus de 25% des parts de l’entreprise.`,
      label: 'Bénéficiaires effectifs manquants',
    },
    KYB_STATUTES_DOC_NOT_SUPPORTED: {
      description:
        'Le document envoyé n’est pas accepté. Transmettez-nous la dernière version des statuts déposés et enregistrés auprès du greffe.',
      label: 'Document non supporté',
    },
    KYB_STATUTES_INCOMPLETE: {
      description:
        'Des pages sont manquantes. Pouvez-vous s‘il-vous-plaît nous fournir la dernière version complète des statuts enregistrés auprès du greffe ?',
      label: 'Incomplet',
    },
    KYB_STATUTES_NOT_AUTHENTICATED: {
      description:
        'Le document envoyé n’est pas entièrement lisible et ne peut pas être étudié correctement. Nous vous invitons à renvoyer votre projet de statuts au format PDF sans modification manuelle (rature, annotations, commentaires, etc.)',
      label: 'Non authentifiable',
    },
    KYB_STATUTES_NOT_COMPLETE: {
      description:
        'Certaines pages manquent au document envoyé et il ne peut pas être traité en l’état. Nous vous invitons à renvoyer votre projet de statuts complet au format PDF (20 Mo max.).',
      label: 'Incomplet',
    },
    KYB_STATUTES_NOT_UP_TO_DATE: {
      description:
        'Vos statuts ne sont pas jour. Transmettez-nous la dernière version complète des statuts déposés et enregistrés auprès du greffe.',
      label: 'Statuts pas à jour',
    },
    KYB_STATUTES_REMOVE_BENEFICIARY: {
      description:
        'Certains associés ne possèdent pas au moins 25% des parts de la société et ne sont pas indiqués comme dirigeants. De ce fait, nous ne pouvons pas les ajouter comme bénéficiaire effectif. Nous vous invitons à nous contacter afin de procéder à la suppression de leur profil.',
      label: 'Supprimer un bénéficiaire invalide',
    },
    KYB_STATUTES_SIGNATURE_MISSING: {
      description:
        'Les statuts doivent être signés. Transmettez-nous la dernière version signé des statuts déposés et enregistrés auprès du greffe.',
      label: 'Statuts non signés',
    },
    KYB_STATUTES_SUBSCRIBERS_LIST_MISSING: {
      description:
        'Merci de nous transmettre la liste des souscripteurs à la constitution en plus de vos statuts.',
      label: 'Listes souscripteurs manquante',
    },
    KYB_STATUTES_WRONG_ACCOUNT_HOLDER: {
      description: `À la lecture de vos documents, il semblerait que vous ne soyez pas le dirigeant de la société. Contactez-nous depuis votre espace personnel ou à l'adresse domicile@shine.fr pour que nous puissions attribuer le rôle de titulaire du compte Shine au dirigeant de la société. `,
      label: 'Mauvais titulaire du compte',
    },
    KYB_UNCLEAR_ACTIVITY: {
      description:
        'Nous avons besoin d’en savoir plus sur l’activité exercée par votre entreprise. Les informations que nous avons ne sont pas assez complètes. Nous vous invitons à nous contacter sur l‘adresse mail domicile@shine.fr en nous donnant un maximum de détails (types de produits vendus ou services proposés, site internet, etc).',
      label: 'KBIS Activité à préciser',
    },
    KYC_BIRTH_PLACE_INCONSISTENT: {
      description:
        'Les informations du document ne correspondent pas aux informations que vous avez saisies lors de votre inscription (lieu de naissance). Merci de mettre à jour vos informations sur votre compte ou fournir un autre document s’il vous plaît.',
      label: 'Lieu de naissance incohérent',
    },
    KYC_DRIVING_LICENCE_NOT_SUPPORTED: {
      description:
        'Nous **n’acceptons pas le permis de conduire** en tant que pièce d’identité. Nous vous invitons à prendre en photo votre passeport ou votre carte d’identité.',
      label: 'Permis de conduire non supporté',
    },
    KYC_HOST_INCONSISTENT_NAME: {
      description:
        'Le prénom et le nom sur le document **ne correspondent pas à ceux de votre hébergeur**. Les données sur sa pièce d’identité, l’attestation d’hébergement et le justificatif de domicile doivent correspondre.',
      label: 'Nom de l’hébergeur incohérent',
    },
    KYC_ID_ASSISTED_DOCUMENT_PHOTO: {
      description:
        "Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que votre visage est bien visible et que vous êtes seul.e sur la vidéo.",
      label: "ID : Photo avec l'aide d'un tiers",
    },
    KYC_ID_ASSISTED_SELFIE: {
      description:
        "Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que votre visage est bien visible et que vous êtes seul.e sur la vidéo.",
      label: "Selfie avec l'aide d'un tiers",
    },
    KYC_ID_ASSISTED_VIDEO: {
      description:
        "Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que votre visage est bien visible et que vous êtes seul.e sur la vidéo.",
      label: "Vidéo avec l'aide d'un tiers",
    },
    KYC_ID_DATE_OF_BIRTH_DOES_NOT_MATCH: {
      description:
        "La date de naissance indiquée sur votre pièce d'identité ne correspond pas à l'information saisie lors de votre inscription. Nous vous invitons à recommencer l'étape de vérification d'identité pour finaliser votre inscription.",
      label: 'Date de naissance non cohérente',
    },
    KYC_ID_DATE_OF_BIRTH_DOES_NOT_MATCH_PREVIOUS_ID: {
      description:
        "La date de naissance indiquée sur votre pièce d'identité ne correspond pas avec document d'identité précédement envoyé. Nous vous invitons à recommencer l'étape de vérification d'identité pour finaliser votre inscription.",
      label:
        "La date de naissance ne correspond pas au document d'identité précédent",
    },
    KYC_ID_DOCUMENT_CONDITION_INSUFFICIENT: {
      description:
        "L’état de votre document ne nous permet pas d'en vérifier l’authenticité. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant de nous transmettre une autre pièce d'identité en cours de validité.",
      label: 'ID : document endommagé',
    },
    KYC_ID_ERROR_OTHER_DOCUMENT: {
      description:
        "Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que votre visage soit suffisamment exposé à la lumière, entièrement visible et que vous ne portez pas de lunettes.",
      label: 'ID : autre erreur',
    },
    KYC_ID_ERROR_OTHER_SELFIE: {
      description:
        "Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que votre visage soit suffisamment exposé à la lumière, entièrement visible et que vous ne portez pas de lunettes.",
      label: 'Selfie : autre erreur',
    },
    KYC_ID_ERROR_OTHER_VIDEO: {
      description:
        "Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que votre visage soit suffisamment exposé à la lumière, entièrement visible et que vous ne portez pas de lunettes.",
      label: 'Vidéo : autre erreur',
    },
    KYC_ID_EXPIRED: {
      description:
        "La pièce d’identité est **expirée**. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant de nous transmettre une autre pièce d'identité en cours de validité (carte d'identité, passeport ou titre de séjour européen). Les permis de conduire ne sont pas acceptés.",
      label: 'Document expiré',
    },
    KYC_ID_EXPIRY_DATE_DOES_NOT_MATCH: {
      description:
        "Les informations indiquées sur votre pièce d'identité ne correspondent pas aux informations saisies lors de votre inscription. Nous vous invitons à recommencer l'étape de vérification d'identité pour finaliser votre inscription.",
      label: "ID : date d'expiration incohérente",
    },
    KYC_ID_GDPR_BREACH: {
      description:
        "Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant votre document d'identité et non celui de quelqu'un d'autre.",
      label: "ID : document d'une autre personne",
    },
    KYC_ID_GDPR_BREACH_SELFIE: {
      description:
        "Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que votre visage est bien visible et que vous êtes seul.e sur la vidéo.",
      label: "Selfie : GDPR - plus d'une personne sur le selfie",
    },
    KYC_ID_GDPR_BREACH_VIDEO: {
      description:
        "Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que votre visage est bien visible et que vous êtes seul.e sur la vidéo.",
      label: "Vidéo : GDPR - plus d'une personne sur la vidéo",
    },
    KYC_ID_INADEQUATE_SELFIE: {
      description:
        "La qualité de la vidéo n'est pas suffisante pour vérifier votre identité. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que votre visage soit suffisamment exposé à la lumière, entièrement visible et que vous ne portez pas de lunettes.",
      label: 'Selfie : inadequat',
    },
    KYC_ID_INADEQUATE_VIDEO: {
      description:
        "Le contenu de la vidéo prise est inapproprié. Nous vous invitons à recommencer l'étape de vérification d'identité.",
      label: 'Video : inapropriée',
    },
    KYC_ID_INCONSISTENT_NAME: {
      description:
        'Le **prénom/nom** que vous avez renseigné **ne correspond pas à celui présent sur la pièce d’identité**. Nous vous invitons à télécharger un nouveau document ou à nous contacter pour que nous mettions à jour votre dossier.',
      label: 'Nom incohérent',
    },
    KYC_ID_INCONSISTENT_SELFIE: {
      description:
        'Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer en faisant en sorte que votre visage soit bien visible.',
      label: 'Selfie incohérent',
    },
    KYC_ID_INCONSISTENT_SELFIE_FACE_NOT_VISIBLE: {
      description:
        "Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que votre visage soit suffisamment exposé à la lumière, entièrement visible et que vous ne portez pas de lunettes.",
      label: 'Selfie : visage partiellement visible / hors champ',
    },
    KYC_ID_INCONSISTENT_SELFIE_NOT_SAME_PERSON: {
      description:
        "Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que votre visage soit suffisamment exposé à la lumière, entièrement visible et que vous ne portez pas de lunettes.",
      label: 'Selfie : personne différente',
    },
    KYC_ID_INCONSISTENT_SELFIE_TOO_BLURRY: {
      description:
        'Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer en faisant en sorte que votre visage soit bien visible.',
      label: 'Selfie : flou',
    },
    KYC_ID_INCONSISTENT_SELFIE_TOO_BRIGHT: {
      description:
        'Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer en faisant en sorte que votre visage soit bien visible.',
      label: 'Selfie : trop lumineux',
    },
    KYC_ID_INCONSISTENT_SELFIE_TOO_DARK: {
      description:
        'Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer en faisant en sorte que votre visage soit bien visible.',
      label: 'Selfie : trop sombre',
    },
    KYC_ID_INCONSISTENT_VIDEO_TOO_BLURRY: {
      description:
        'Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer en faisant en sorte que votre visage soit bien visible.',
      label: 'Vidéo : trop flou',
    },
    KYC_ID_INCONSISTENT_VIDEO_TOO_BRIGHT: {
      description:
        'Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer en faisant en sorte que votre visage soit bien visible.',
      label: 'Vidéo : trop lumineux',
    },
    KYC_ID_INCONSISTENT_VIDEO_TOO_DARK: {
      description:
        'Nous avons des difficultés à établir une **correspondance entre votre pièce d’identité et la vidéo prise**. Nous vous invitons à recommencer en faisant en sorte que votre visage soit bien visible.',
      label: 'Vidéo : trop sombre',
    },
    KYC_ID_INVERTED: {
      description:
        'Le recto et le verso de votre pièce d’identité sont inversés. Merci de photographier l’avant de la pièce d’identité en premier puis l’arrière.',
      label: 'ID recto/verso inversés',
    },
    KYC_ID_ISSUE_DATE_DOES_NOT_MATCH: {
      description:
        "Les informations indiquées sur votre pièce d'identité ne correspondent pas aux informations saisies lors de votre inscription. Nous vous invitons à recommencer l'étape de vérification d'identité pour finaliser votre inscription.",
      label: "ID : date d'émission incohérente",
    },
    KYC_ID_KYC_GENDER_DOES_NOT_MATCH: {
      description:
        "Le genre indiqué sur votre pièce d'identité ne correspond pas à l'information saisie lors de votre inscription. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que le genre sélectionné correspond à celui indiqué sur votre document d'identité ou à nous contacter à l'adresse suivante : domicile@shine.fr pour que nous mettions à jour votre dossier.",
      label: 'Genre non cohérent',
    },
    KYC_ID_KYC_INVALID_ID_DOCUMENT: {
      description:
        "La pièce d'identité transmise ne correspond pas au type de document que vous avez sélectionné lors de votre inscription. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant de séléctionner le bon type de document à envoyer.",
      label: 'ID : correspondance avec le type de document sélectionné',
    },
    KYC_ID_LIVENESS_FEATURE: {
      description:
        "La qualité de la vidéo n'est pas suffisante pour vérifier votre identité. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que votre visage soit suffisamment exposé à la lumière, entièrement visible et que vous ne portez pas de lunettes.",
      label: 'Video : personne en direct non detecté',
    },
    KYC_ID_NAME_DOES_NOT_MATCH_PREVIOUS_ID: {
      description:
        "Le nom/prénom indiqué sur votre pièce d'identité ne correspond pas avec le document d'identité précédement envoyé. Nous Nous vous invitons à recommencer l'étape de vérification d'identité pour finaliser votre inscription.",
      label: "Le nom/prénom ne correspond pas au document d'identité précédent",
    },
    KYC_ID_NAME_FIELDS_DOES_NOT_MATCH: {
      description:
        "Le nom/prénom indiqué sur votre pièce d'identité ne correspond pas à l'information saisie lors de votre inscription. Nous vous invitons à recommencer l'étape de vérification d'identité pour finaliser votre inscription.",
      label: 'ID : nom incohérent',
    },
    KYC_ID_NATIONALITY_DOES_NOT_MATCH: {
      description:
        "La nationalité indiquée sur votre pièce d'identité ne correspond pas à l'information saisie lors de votre inscription. Nous vous invitons à recommencer l'étape de vérification d'identité pour finaliser votre inscription.",
      label: 'Nationalité non cohérente',
    },
    KYC_ID_NUMBER_DOES_NOT_MATCH: {
      description:
        "Les informations indiquées sur votre pièce d'identité ne correspondent pas aux informations saisies lors de votre inscription. Nous vous invitons à recommencer l'étape de vérification d'identité pour finaliser votre inscription.",
      label: "ID : numéro de l'ID incohérent",
    },
    KYC_ID_PHOTO_BLOCKED: {
      description:
        "Le document d'identité transmis est en partie masqué. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant que toutes les informations soient lisibles. Les captures d'écran, photos d'écran, photocopies et scans ne sont pas acceptés.",
      label: 'ID : partie non visible',
    },
    KYC_ID_PLACE_OF_BIRTH_DOES_NOT_MATCH: {
      description:
        "Le lieu de naissance indiqué sur votre pièce d'identité ne correspond pas à l'information saisie lors de votre inscription. Nous vous invitons à recommencer l'étape de vérification d'identité pour finaliser votre inscription.",
      label: 'Lieu de naissance non cohérent',
    },
    KYC_ID_PLACE_OF_BIRTH_DOES_NOT_MATCH_PREVIOUS_ID: {
      description:
        "La lieu de naissance indiqué sur votre pièce d'identité ne correspond pas avec le document d'identité précédement envoyé. Nous vous invitons à recommencer l'étape de vérification d'identité pour finaliser votre inscription.",
      label:
        "Le lieu de naissance ne correspond pas au document d'identité précédent",
    },
    KYC_ID_PLASTIC_COVER: {
      description:
        "La protection plastique de votre pièce d'identité ne nous permet pas d'en vérifier l’authenticité. Nous vous invitons à recommencer l'étape de vérification d'identité en vous assurant de nous transmettre une photo de votre pièce d'identité hors de sa protection plastique.",
      label: 'ID : document dans une protection plastique',
    },
    KYC_ID_RECTO_VERSO_MISSING: {
      description:
        'L’un des côtés de votre pièce d’identité est manquant. Nous vous invitons à recommencer en nous envoyant le **recto** (l’avant) **et** le **verso** (l’arrière).',
      label: 'ID Recto ou verso manquant',
    },
    KYC_MISSING_SELFIE: {
      description:
        'Une erreur s’est produite avec votre pièce d’identité. Nous vous recommandons de télécharger la dernière version de l’application mobile Shine et à nous soumettre de nouveau votre document d’identité. Nous sommes désolés pour la gêne occasionnée.',
      label: 'Selfie manquant',
    },
    KYC_PASSPORT_HOST_PAGE_MISSING: {
      description:
        'Pourriez-vous reprendre une photo du passeport complet de votre hébergeur, avec la **page de signature** dans un espace lumineux et sans reflets ?',
      label: 'Deuxième page manquante',
    },
    KYC_PASSPORT_NON_EUROPEAN: {
      description:
        'Nous vous invitons à nous transmettre votre titre de séjour recto/verso pour que nous puissions ouvrir votre compte.',
      label: 'Passeport non européen',
    },
    KYC_PASSPORT_SECOND_PAGE_MISSING: {
      description:
        'Les **deux volets de votre passeport** sont nécessaires pour que nous puissions le valider. Nous vous invitons à reprendre en photo les deux pages (celle avec votre signature, et celle avec votre photo) de votre document (version originale) en portant une attention particulière à sa lisibilité, aux reflets et à sa luminosité.',
      label: 'Seconde page du passeport manquante',
    },
    KYC_POA_4G_BOX: {
      description:
        ' Les factures internet 4G ne sont pas supportées. Nous vous invitons à nous fournir un autre justificatif de domicile (facture internet, téléphone fixe, attestation de contrat énergie, etc…).',
      label: 'Box 4G',
    },
    KYC_POA_COMPANY_NAME: {
      description:
        'Nous n’acceptons pas les **justificatifs de domicile au nom de votre entreprise**. Ce document nous permet de justifier votre adresse personnelle, et non celle de votre société. Nous vous invitons à nous envoyer une nouvelle pièce.',
      label: 'Justificatif de domicile au nom de l’entreprise',
    },
    KYC_POA_ENDED_INVOICE: {
      description:
        'Les factures de résiliation ne sont pas supportées. Nous vous invitons à nous fournir un autre justificatif de domicile (facture internet, téléphone fixe, attestation de contrat énergie, etc…).',
      label: 'Facture de résiliation',
    },
    KYC_POA_EXPIRED: {
      description:
        'Le justificatif de domicile que vous nous avez transmis n’est plus valable : il est **expiré**. Nous avons besoin d’un document **daté de moins de 3 mois**.',
      label: 'Justificatif de domicile expiré',
    },
    KYC_POA_FIRSTNAME_MISSING: {
      description:
        'Le prénom doit être présent sur le justificatif de domicile.',
      label: 'Aucun prénom sur le justificatif de domicile',
    },
    KYC_POA_INCONSISTENT_ADDRESS: {
      description:
        'L’adresse sur le document ne correspond pas à celle que vous avez saisie au moment de votre inscription. Nous vous invitons à nous contacter pour la modifier ou à nous transmettre un autre justificatif de domicile avec votre **adresse personnelle** inscrite dessus.',
      label: 'Justificatif de domicile adresse incohérente',
    },
    KYC_POA_INCONSISTENT_NAME: {
      description:
        'Le prénom et le nom ne correspondent pas à ceux indiqués dans votre dossier. Si vous êtes hébergé·e, vous devez cocher "Je suis hébergé·e" au moment d\'ajouter votre justificatif de domicile et nous transmettre un document au nom complet de votre hébergeur.',
      label: 'Justificatif de domicile nom incohérent',
    },
    KYC_POA_MOBILE: {
      description:
        'Les factures mobiles ne sont pas supportées. Nous vous invitons à nous fournir un autre justificatif de domicile (facture internet, téléphone fixe, attestation de contrat énergie, etc…).',
      label: 'Facture mobile',
    },
    KYC_POA_NAME_SLIGHTLY_DIFFERENT: {
      description:
        'Le prénom et le nom sur le justificatif de domicile doivent être **identiques à la pièce d’identité**, merci de contacter votre fournisseur pour qu’il fasse le changement sur votre document.',
      label: 'Nom légèrement différent',
    },
    KYC_POA_NO_CONTROL_POINT: {
      description:
        'Nous ne pouvons pas vérifier l’authenticité de ce document. Nous vous invitons à nous fournir un autre justificatif de domicile.',
      label: 'Pas de point de contrôle',
    },
    KYC_POA_NOT_SUPPORTED: {
      description:
        "Ce justificatif de domicile **n’est pas accepté**. Nous aurions besoin, soit d’une **facture internet, téléphone fixe ou d'énergie** (eau, gaz ou électricité) de **moins de 3 mois**, soit de votre **dernier avis d’imposition** sur le revenu, taxe d’habitation ou taxe foncière, ou encore une **attestation de contrat** énergie, eau ou télécoms (doit comporter un code barre 2D-DOC).",
      label: 'Justificatif de domicile non supporté',
    },
    KYC_POA_PAYMENT_SCHEDULE: {
      description:
        'Les échéanciers de paiement ne sont pas supportés. Nous vous invitons à nous fournir un autre justificatif de domicile (facture internet, téléphone fixe, attestation de contrat énergie, etc…).',
      label: 'Calendrier de paiement',
    },
    KYC_POA_PLACE_OF_CONSUMPTION_ADDRESS: {
      description:
        'L’adresse du **lieu de consommation est différente de l’adresse postale**. Nous ne pouvons pas accepter votre document puisque seule l’adresse postale compte. Nous vous invitons à nous transmettre un autre justificatif de domicile à votre adresse (facture internet ou de téléphone fixe par exemple).',
      label: 'Justificatif de domicile adresse lieu de consommation',
    },
    KYC_POA_PRINTED: {
      description:
        'Merci de nous envoyer la version officielle et complète au format pdf s’il vous plaît (téléchargée directement depuis le site de votre fournisseur).',
      label: 'POA imprimé',
    },
    KYC_POA_SCREENSHOT: {
      description:
        'Les captures d’écrans ne sont pas acceptées. Merci de nous fournir la version officielle et complète au format pdf s’il vous plaît (téléchargée directement depuis le site de votre fournisseur).',
      label: 'POA screenshot',
    },
    KYC_POA_UNPAID_INVOICE: {
      description:
        'La facture a un montant impayé trop important. Nous vous invitons à nous fournir un autre justificatif de domicile (facture internet, téléphone fixe, attestation de contrat énergie, etc…).',
      label: 'Impayé trop important',
    },
    KYC_PROOF_OF_ACCOMMODATION_ESIGNATURE: {
      description:
        'Nous **ne pouvons pas accepter les signatures numériques**. Nous vous invitons à imprimer l’attestation et à la faire signer par votre hébergeur. Vous pourrez ensuite la prendre en photo et nous la transmettre.',
      label: 'Attestation d’hébergement e-signature',
    },
    KYC_PROOF_OF_ACCOMMODATION_EXPIRED: {
      description:
        'L’attestation d’hébergement n’est plus valable : elle est **expirée**. Nous avons besoin d’un document **daté de moins de 3 mois** et signé par votre hébergeur.',
      label: 'Attestation d’hébergement expirée',
    },
    KYC_PROOF_OF_ACCOMMODATION_HOST_BIRTHDATE_MISMATCH: {
      description:
        'Pourriez-vous rectifier la date de naissance de votre hébergeur sur l’attestation d’hébergement afin qu’elle soit identique à sa pièce d’identité ?',
      label: 'Attestation d’hébergement date de naissance de l’hébergeur',
    },
    KYC_PROOF_OF_ACCOMMODATION_INCONSISTENT_ADDRESS: {
      description:
        'L’adresse sur le document ne correspond pas à celle que vous avez saisie au moment de votre inscription. Nous vous invitons à nous contacter pour la modifier ou à nous transmettre une autre attestation d’hébergement avec votre **adresse personnelle** inscrite dessus.',
      label: 'Adresse incorrecte',
    },
    KYC_PROOF_OF_ACCOMMODATION_INCONSISTENT_SIGNATURE: {
      description:
        'La **signature doit être identique** à celle présente sur la pièce d’identité de votre hébergeur.',
      label: 'Attestation d’hébergement signature différente',
    },
    KYC_PROOF_OF_ACCOMMODATION_NAME_SLIGHTLY_DIFFERENT: {
      description:
        'Le prénom et le nom sur l’attestation d’hébergement doivent être identiques à la pièce d’identité. Pourriez-vous la modifier ?',
      label: 'Nom légèrement différent',
    },
    KYC_PROOF_OF_ACCOMMODATION_SIGNATURE_MISSING: {
      description:
        'La **signature de votre hébergeur est manquante** sur l’attestation. Nous vous invitons à l’imprimer et à la faire signer (signature manuscrite) par votre hébergeur, avant de nous la renvoyer. Notez que la signature doit être la même que celle sur sa pièce d’identité.',
      label: 'Attestation d’hébergement signature manquante',
    },
    KYC_PROOF_OF_ACCOMMODATION_USER_BIRTHDATE_MISMATCH: {
      description:
        'Pourriez-vous rectifier votre date de naissance sur l’attestation d’hébergement afin qu’elle soit identique à votre pièce d’identité ?',
      label: 'Attestation d’hébergement date de naissance',
    },
    KYC_RESIDENCE_PERMIT_HOST_MISSING: {
      description:
        'Pouvez-vous nous transmettre le titre de séjour recto verso de votre hébergeur via l’application et son récépissé par mail à l’adresse suivante : domicile@shine.fr ?',
      label: 'Titre de séjour hébergeur manquant',
    },
    KYC_RESIDENCE_PERMIT_MISSING: {
      description:
        'Pouvez-vous nous transmettre votre titre de séjour recto verso via l’application et votre récépissé par mail à l’adresse suivante : domicile@shine.fr ?',
      label: 'Titre de séjour manquant',
    },
    KYC_SHINE_START_POA_MENTION_MICRO_MISSING: {
      description:
        'La mention suivante est manquante sur votre attestation d’hébergement. Nous vous invitons à demander à votre hébergeur de la rajouter, ou votre dossier risque d’être refusé par l’administration française : **Certifie sur l’honneur que j’autorise l’hébergé(e) ci-dessous à domicilier sa micro-entreprise à mon domicile mentionné ci-dessus**.',
      label: 'Mention domiciliation micro manquante (Shine Start)',
    },
    KYC_SHINE_START_POA_NOT_SUPPORTED: {
      description:
        "Ce justificatif de domicile **n’est pas accepté**. Nous aurions besoin, soit d’une **facture internet, téléphone fixe ou d'énergie** (eau, gaz ou électricité) de **moins de 3 mois**, soit une **attestation de contrat** énergie, eau ou télécoms (doit comporter un code barre 2D-DOC).",
      label: 'Document non supporté (Shine Start)',
    },
    KYC_SHINE_START_RESIDENCE_PERMIT_HOST_INCONSISTENT_ADDRESS: {
      description:
        'L’adresse indiquée sur le titre de séjour de votre hébergeur est **différente de celle indiquée sur le justificatif de domicile**. Nous l’invitons à effectuer une demande de changement d’adresse pour le titre de séjour, sans quoi l’État risque de refuser votre dossier de création d’entreprise.',
      label: 'Adresse incohérente hébergeur (Shine Start)',
    },
    KYC_SHINE_START_RESIDENCE_PERMIT_INCONSISTENT_ADDRESS: {
      description:
        "L’adresse indiquée sur le titre de séjour est **différente de celle indiquée sur le justificatif de domicile**. Nous vous invitons à effectuer une demande de changement d’adresse pour le titre de séjour, sans quoi l'État risque de refuser votre dossier de création d’entreprise.",
      label: 'Adresse incohérente (Shine Start)',
    },
    MISSING: {
      description:
        'Nous ne pouvons finaliser votre inscription sans ce document. Merci de nous le renvoyer s’il vous plaît.',
      label: 'Document manquant',
    },
    NEED_ANOTHER: {
      description:
        'Le document que vous avez transmis ne peut être validé. Merci de nous transmettre un autre document s’il vous plaît.',
      label: 'Invalide',
    },
    NO_DATE: {
      description:
        'Ce document n’est pas daté et ne peut être validé. Merci de nous transmettre un autre document s’il vous plaît.',
      label: 'Date manquante',
    },
    NO_SIGNATURE: {
      description:
        'La signature n’est pas visible sur le document fourni ou la signature présente sur le document ne correspond pas à celle de votre hébergeur. Merci de nous renvoyer le document avec la signature s’il vous plaît.',
      label: 'Signature manquante',
    },
    NOT_AUTHENTICATED: {
      description:
        'La qualité de votre document ne nous permet pas d‘en vérifier l’authenticité. Toutes les informations doivent être lisibles. Merci de nous renvoyer une photo bien nette et complète de votre document s’il vous plaît (bordures visibles).',
      label: 'Non authentifiable',
    },
    OUT_OF_BOUNDS: {
      description:
        'Ce document d’identité ne vous permet pas d’ouvrir un compte chez Shine. Merci de fournir un titre de séjour en cours de validité s’il vous plaît.',
      label: 'Titre de séjour nécessaire',
    },
    PHOTOCOPY: {
      description:
        "Les photocopies et scans ne sont pas acceptés. Nous vous invitons à recommencer l'étape de vérification d'identité pour finaliser votre inscription.",
      label: 'Photocopie',
    },
    SCAN: {
      description:
        'Merci de nous fournir une photo du document et non un scan de celui-ci.',
      label: 'Document scanné',
    },
    SCREEN: {
      description:
        "Les photos d'écran, de scan ou de photocopies ne sont pas acceptées. Vous devez être en possession du **document original** au moment où vous le prenez en photo.",
      label: 'Photo d’un écran/photocopie',
    },
    SCREENSHOT: {
      description:
        'Les captures écran ne sont pas acceptées. Merci de nous fournir une photo de votre courrier ou d‘envoyer le document en format PDF original.',
      label: 'Screenshot',
    },
    TYPE_NOT_SUPPORTED: {
      description:
        'Ce type de document ne fait malheureusement pas partie des documents acceptés. Merci de fournir un autre document s’il vous plaît. Nous vous invitons à consulter la FAQ.',
      label: 'Document non supporté',
    },
    UNREADABLE: {
      description:
        "La qualité de la photo ne nous permet pas de vérifier l’authenticité du document. Toutes les informations doivent être lisibles. Merci de nous renvoyer une photo bien nette du document s’il vous plaît. Les captures d'écran et photos d'écran ne sont pas supportées.",
      label: 'Illisible',
    },
    UPLOAD_ERROR: {
      description:
        'Une erreur s’est produite lors du téléchargement du document et il ne peut pas s’ouvrir. Nous vous invitons à recommencer en ajoutant un document au format PDF (20 Mo max.). Nous sommes désolés pour la gêne occasionnée.',
      label: 'Problème d’upload',
    },
  },
};

module.exports = {
  ERROR_TAGS,
  errorTagsLocales,
};
